/*
 * @Author: Tahiti
 * @Date: 2025-01-27 12:00:00
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-31 17:54:22
 * @Description: Pricing 页面多语言配置
 * @FilePath: /weryai-web/locales/modules/pricing.ts
 */
export default {
    zh: {
        getMonthlyCredits: '{count} 积分/月',
        // 页面标题
        plansAndPricing: '套餐与定价',
        getAccessDescription: '获得更多生成次数和新功能的优先访问权限',

        // 计费周期
        monthly: '月付',
        yearly: '年付',
        yearlyDiscount: '最低6折',
        payAsYouGo: '按需付费',

        // 套餐名称
        basic: '基础版',
        standard: '标准版',
        pro: '专业版',
        popular: '热门',

        // 价格相关
        month: '/月',
        billedYearly: '年付',
        billedMonthly: '月付',
        create: '立即购买',

        // 积分相关
        creditsPerMonth: '积分/月',
        creditsInstantly: '积分立即到账！',
        getCreditsInstantly: '🎉每月可获得 {count} 积分！',

        // 功能特性
        textImageVideoToVideo: '文本/图片/视频转视频',
        upToImages: '最多 {count} 张图片',
        upToVideos: '最多 {count} 个视频',
        noWatermarkOutputs: '无水印输出',
        unlimitedEditTools: '无限制 AI 编辑工具',
        priorityFastGeneration: '优先通道极速生成',

        // FAQ 部分
        frequentlyAskedQuestions: '常见问题',
        cantFindAnswer: '找不到您要的答案？',

        // FAQ 问题
        paymentMethodsQuestion: '你们接受哪些支付方式？',
        paymentMethodsAnswer:
            '我们接受各种支付方式，包括主要的信用卡，如 Visa、MasterCard、American Express 等。',

        creditsDeductionQuestion: '图片或视频生成时如何扣除我的积分？',
        creditsDeductionAnswer:
            '您的积分使用基于几个因素，包括您选择的工具和模型、视频时长、输出数量以及图片或视频的分辨率。',

        creditsRolloverQuestion: '未使用的积分会结转到下一个计费周期吗？',
        creditsRolloverAnswer:
            '未使用的积分会转结到下一个计费周期，可以继续使用',

        needMoreCreditsQuestion: '如果我需要更多积分怎么办？',
        needMoreCreditsAnswer:
            '对于免费和轻量版用户，您可以升级套餐以获得更多积分。对于专业版用户，您可以轻松滑动上面专业版套餐下方的积分条来根据需要购买额外积分。只需将滑块拖到您想要购买的额外积分数量即可。',

        checkCreditStatusQuestion: '如何查看我的积分状态？',
        checkCreditStatusAnswer:
            '您可以通过查看屏幕右上角或访问账单页面来查看您的积分状态。在那里，您会看到您还剩多少月度积分。',

        hiddenFeesQuestion: '是否有隐藏费用？',
        hiddenFeesAnswer:
            '不，您看到的价格就是您支付的价格。除了您选择的套餐外，没有额外的隐藏费用。',

        refundPolicyQuestion: '你们的退款政策是什么？',
        refundPolicyAnswer: `首次购买后 3 天内，您可以申请退款。请阅读<a href='https://weli.art/refund-policy' target='_blank' style='color: #4a9eff;text-decoration: underline;' >《微鲤AI退款政策》</a>了解更多详情。`,
        single_price: '¥{price} 每积分',
        payResult: {
            title: '支付结果',
            loading: '支付中...',
            success: '支付成功',
            failed: '支付失败',
        },
        choosePlan: '选择您的套餐',
        choosePlanDescription:
            '升级到标准或专业版，一次上传最多 {count} 张图片！',
        never_expire: '永久有效',
        credits_monthly: '{count} 积分/月',
        actually: '实际',
        nanoAndSora: 'NanoBanana和Sora2模型',

        hotImageModel: '当下热门AI图片模型',
        hotVideoModel: '当下热门AI视频模型',
        videoBgRemove: '视频消除背景',
        videoWatermarkRemove: '视频去水印',
        imageSizeControl: '图片比例转化',
        moreTaskRunning: '多任务并行',
        speed1: '更快的生成速度',
        speed2: '超快的生成速度',
        speed3: '优先通道极速生成',
        copyrightProtection: '版权保护',
        maxConcurrentTasks: '最多同时 {count} 任务',
        yearlyDiscountNumber: '节省{discount}',
        hasSubscription: '当前订阅已激活',
        choosePaymentMethod: '选择支付方式',
        orderGoods: '下单商品',
        paymentInformationIsSafe: '您的支付信息是安全的。',
        cancelSubscription: '您可以随时取消订阅',
        payLoading: '创建订单中...',
        payConfirm: '立即支付',
        supperMainbank: '支持主流银行卡与本地支付渠道',
        globalCreditCard: '全球通用信用卡 / 借记卡支付',
        // Airwallex 支付相关
        airwallex: {
            title: '信用卡支付',
            subtitle: '请输入您的信用卡信息以完成支付',
            loading: '正在初始化支付...',
            processing: '处理中...',
            payNow: '立即支付',
            success: '支付成功！',
            initError: '支付系统初始化失败，请稍后重试',
            createElementError: '创建支付表单失败，请稍后重试',
            paymentError: '支付失败，请重试',
            confirmError: '支付确认失败，请重试',
            invalidGoods: '商品信息无效',
            cardNumber: '卡号',
            expiryDate: '有效期',
            cvv: '安全码',
            cardholderName: '卡片上的姓名',
            recaptchaError: '无法连接到验证服务，请检查网络连接后重试',
            retry: '重试',
        },
        chat_pro: '聊天会员',
        can_cancel_at_any_time: '灵活订阅，随时取消',
        only_need: '仅需：',
        day_price: '{price}/天',
        chat_month_vip: '月度会员',
        chat_year_vip: '年度会员',
        year: '/年',
        can_cancel_at_any_time_yearly: '立省$100，长期陪伴首选',
        PLAN_PRO_description: '适合专业创作者',
        PLAN_ENTRY_description: '适合入门创作者',
        PLAN_BASIC_description: '适合进阶创作者',
        get_credits_instantly: '每月可获得',
        get_credits_count: '{count} 积分',
        VIP: 'VIP',
        credits: '积分',
        chat_plan: '聊天VIP',
        max_music_count: '最多 {count} 首音乐',
    },
    en: {
        getMonthlyCredits: '{count} credits/month',
        // Page titles
        plansAndPricing: 'Plans & Pricing',
        getAccessDescription:
            'Get access to more generations and priority access to new features',

        // Billing cycles
        monthly: 'Monthly',
        yearly: 'Yearly',
        yearlyDiscount: 'Save up to 50%',
        payAsYouGo: 'Pay As You Go',

        // Plan names
        basic: 'Basic',
        standard: 'Standard',
        pro: 'Pro',
        popular: 'Popular',

        // Pricing related
        month: '/Month',
        billedYearly: 'Billed yearly',
        billedMonthly: 'Billed monthly',
        create: 'Buy Now',

        // Credits related
        creditsPerMonth: 'credits/month',
        creditsInstantly: 'credits instantly!',
        getCreditsInstantly: '🎉Get {count} credits every month!',

        // Features
        textImageVideoToVideo: 'Text/Image/Video to video',
        upToImages: 'up to {count} image',
        upToVideos: 'up to {count} video',
        noWatermarkOutputs: 'No-watermark outputs',
        unlimitedEditTools: 'Unlimited AI editing tools',
        priorityFastGeneration: 'Priority fast generation',

        // FAQ section
        frequentlyAskedQuestions: 'Frequently Asked Questions',
        cantFindAnswer: "Can't find the answer you're looking for?",

        // FAQ questions
        paymentMethodsQuestion: 'What payment methods do you accept?',
        paymentMethodsAnswer:
            'We accept various payment methods, including major credit cards such as Visa, MasterCard, American Express, etc.',

        creditsDeductionQuestion:
            'How are my credits deducted for image or video generation?',
        creditsDeductionAnswer:
            'Your credits are used up based on a few factors including the tools and models you choose, the duration of videos, the quantity of outputs, and the resolution of the images or videos.',

        creditsRolloverQuestion:
            'Do unused credits roll over to the next billing cycle?',
        creditsRolloverAnswer:
            'Unused credits will carry over to the next billing cycle, can be used again',

        needMoreCreditsQuestion: 'What if I need more credits?',
        needMoreCreditsAnswer:
            'For Free and Lite users, you can upgrade your plans to get more credits. For Pro users, you can easily slide the credit bar below the Pro plan above to purchase extra credits as needed. Simply drag the slider to the desired amount of additional credits you want to buy.',

        checkCreditStatusQuestion: 'How to check my credit status?',
        checkCreditStatusAnswer:
            "You can check your credit status by looking in the top right corner of the screen or visiting the Billing page. There, you'll see how many monthly credits you have left.",

        hiddenFeesQuestion: 'Are there any hidden fees?',
        hiddenFeesAnswer:
            'No, the price you see is the price you pay. There are no additional hidden charges beyond the plan you select.',

        refundPolicyQuestion: 'What is your refund policy?',
        refundPolicyAnswer: `You can request a refund within 3 days of your first purchase. Please read our <a href='https://weli.art/refund-policy' target='_blank' style='color: #4a9eff;text-decoration: underline;' >Refund Policy</a> for more details.`,
        single_price: '${price} per credit',
        payResult: {
            title: 'Payment Result',
            loading: 'Payment in progress...',
            success: 'Payment successful',
            failed: 'Payment failed',
        },
        choosePlan: 'Choose Your Plan',
        choosePlanDescription:
            'Upgrade to Standard or Pro to upload up to {count} images at once!',
        never_expire: 'Never Expire',
        credits_monthly: '{count} credits/month',
        actually: 'Actually',
        nanoAndSora: 'NanoBanana and Sora2 model',

        hotImageModel: 'Trending AI image models',
        hotVideoModel: 'Trending AI video models',
        videoBgRemove: 'Video background removal',
        videoWatermarkRemove: 'Video watermark removal',
        imageSizeControl: 'Image aspect ratio conversion',
        moreTaskRunning: 'Multiple tasks running in parallel',
        speed1: 'Faster generation speed',
        speed2: 'Super fast generation speed',
        speed3: 'Priority ultra-fast generation',
        copyrightProtection: 'Copyright protection',
        maxConcurrentTasks: 'Up to {count} concurrent tasks',
        yearlyDiscountNumber: 'Save {discount}',
        hasSubscription: 'Current subscription is active',
        choosePaymentMethod: 'Choose Payment Method',
        orderGoods: 'Order Goods',
        paymentInformationIsSafe: 'Your payment information is secure.',
        cancelSubscription: 'You can cancel your subscription at any time',
        payLoading: 'Creating order...',
        payConfirm: 'Pay Now',
        supperMainbank: 'Supports major bank cards and local payment channels',
        globalCreditCard: 'Global credit card / debit card payment',
        // Airwallex payment related
        airwallex: {
            title: 'Credit Card Payment',
            subtitle:
                'Please enter your credit card information to complete the payment',
            loading: 'Initializing payment...',
            processing: 'Processing...',
            payNow: 'Pay Now',
            success: 'Payment successful!',
            initError:
                'Payment system initialization failed, please try again later',
            createElementError:
                'Failed to create payment form, please try again later',
            paymentError: 'Payment failed, please try again',
            confirmError: 'Payment confirmation failed, please try again',
            invalidGoods: 'Invalid product information',
            cardNumber: 'Card Number',
            expiryDate: 'Expiry Date',
            cvv: 'CVV',
            cardholderName: 'Name on Card',
            recaptchaError:
                'Could not connect to verification service. Please check your internet connection and try again.',
            retry: 'Retry',
        },
        chat_pro: 'Chat VIP',
        can_cancel_at_any_time: 'Flexible subscription, cancel anytime',
        only_need: 'Only need:',
        day_price: '{price}/day',
        chat_month_vip: 'Monthly VIP',
        chat_year_vip: 'Yearly VIP',
        year: '/Year',
        can_cancel_at_any_time_yearly:
            'Save $100 instantly, the top choice for long-term use',
        PLAN_PRO_description: 'Ideal for professional creators',
        PLAN_ENTRY_description: 'Ideal for beginning creators',
        PLAN_BASIC_description: 'Ideal for advanced creators',
        get_credits_instantly: 'Receive monthly',
        get_credits_count: '{count} credits',
        VIP: 'VIP',
        credits: 'Credits',
        chat_plan: 'Chat VIP',
        max_music_count: 'Up to {count} music',
    },
    ja: {
        getMonthlyCredits: '{count} クレジット/月',
        // ページタイトル
        plansAndPricing: 'プランと料金',
        getAccessDescription:
            'より多くの生成回数と新機能への優先アクセスを取得',

        // 請求サイクル
        monthly: '月額',
        yearly: '年額',
        yearlyDiscount: '最大50％割引',
        payAsYouGo: '従量課金',

        // プラン名
        basic: 'ベーシック',
        standard: 'スタンダード',
        pro: 'プロ',
        popular: '人気',

        // 料金関連
        month: '/月',
        billedYearly: '年額請求',
        billedMonthly: '月額請求',
        create: '今すぐ購入',

        // クレジット関連
        creditsPerMonth: 'クレジット/月',
        creditsInstantly: 'クレジット即座に！',
        getCreditsInstantly: '🎉毎月 {count} クレジットを獲得！',

        // 機能
        textImageVideoToVideo: 'テキスト/画像/動画から動画へ',
        upToImages: '最大 {count} 画像',
        upToVideos: '最大 {count} 動画',
        noWatermarkOutputs: '透かしなし出力',
        unlimitedEditTools: '無制限のAI編集ツール',
        priorityFastGeneration: '優先高速生成',

        // FAQ セクション
        frequentlyAskedQuestions: 'よくある質問',
        cantFindAnswer: 'お探しの答えが見つかりませんか？',

        // FAQ 質問
        paymentMethodsQuestion: 'どの支払い方法を受け付けていますか？',
        paymentMethodsAnswer:
            'Visa、MasterCard、American Express などの主要クレジットカードを含む、さまざまな支払い方法を受け付けています。',

        creditsDeductionQuestion:
            '画像や動画生成時にクレジットはどのように差し引かれますか？',
        creditsDeductionAnswer:
            'クレジットの使用は、選択したツールやモデル、動画の長さ、出力数、画像や動画の解像度など、いくつかの要因に基づきます。',

        creditsRolloverQuestion:
            '未使用のクレジットは次の請求サイクルに繰り越されますか？',
        creditsRolloverAnswer:
            '未使用のクレジットは次の請求サイクルに繰り越され、引き続き使用できます',

        needMoreCreditsQuestion:
            'もっとクレジットが必要な場合はどうすればよいですか？',
        needMoreCreditsAnswer:
            '無料ユーザーとライトユーザーの場合、プランをアップグレードしてより多くのクレジットを取得できます。プロユーザーの場合、上記のプロプランの下にあるクレジットバーを簡単にスライドして、必要に応じて追加クレジットを購入できます。スライダーを希望する追加クレジット数までドラッグするだけです。',

        checkCreditStatusQuestion:
            'クレジットステータスを確認するにはどうすればよいですか？',
        checkCreditStatusAnswer:
            '画面の右上を見るか、請求ページにアクセスしてクレジットステータスを確認できます。そこでは、残りの月間クレジット数を確認できます。',

        hiddenFeesQuestion: '隠れた料金はありますか？',
        hiddenFeesAnswer:
            'いいえ、表示されている価格が支払う価格です。選択したプラン以外に追加の隠れた料金はありません。',

        refundPolicyQuestion: '返金ポリシーは何ですか？',
        refundPolicyAnswer: `初回購入後3日以内であれば、返金を申請できます。詳しくは<a href='https://weli.art/refund-policy' target='_blank' style='color: #4a9eff;text-decoration: underline;' >返金ポリシー</a>をご覧ください。`,
        single_price: '${price} クレジットあたり',
        payResult: {
            title: '支払い結果',
            loading: '支払い中...',
            success: '支払い成功',
            failed: '支払い失敗',
        },
        choosePlan: 'プランを選択',
        choosePlanDescription:
            'スタンダードまたはプロにアップグレードして、一度に最大 {count} 枚の画像をアップロード！',
        never_expire: '永続有効',
        credits_monthly: '{count} クレジット/月',
        actually: '実際',
        nanoAndSora: 'NanoBananaとSora2モデル',

        hotImageModel: '今人気のAI画像モデル',
        hotVideoModel: '今人気のAI動画モデル',
        videoBgRemove: '動画背景除去',
        videoWatermarkRemove: '動画ウォーターマーク削除',
        imageSizeControl: '画像アスペクト比変換',
        moreTaskRunning: '複数タスクの並行実行',
        speed1: 'より速い生成速度',
        speed2: '超高速生成',
        speed3: '優先レーンによる超高速生成',
        copyrightProtection: '著作権保護',
        maxConcurrentTasks: '最大同時 {count} タスク',
        yearlyDiscountNumber: '{discount} 割引',
        hasSubscription: '現在のサブスクリプションはアクティブです',
        choosePaymentMethod: '支払い方法を選択',
        orderGoods: '商品を注文',
        paymentInformationIsSafe: 'お客様の支払い情報は安全です。',
        cancelSubscription: 'いつでもサブスクリプションをキャンセルできます',
        payLoading: '注文を作成中...',
        payConfirm: '今すぐ支払う',
        supperMainbank: '主要な銀行カードとローカル決済チャネルをサポート',
        globalCreditCard: 'グローバルクレジットカード / デビットカード決済',
        chat_pro: 'チャット会員',
        can_cancel_at_any_time: 'フレキシブルな購読、いつでもキャンセル可能',
        only_need: 'わずか：',
        day_price: '{price}/日',
        chat_month_vip: '月度会員',
        chat_year_vip: '年度会員',
        year: '/年',
        can_cancel_at_any_time_yearly: '今すぐ$100節約、長期利用に最適',
        PLAN_PRO_description: 'プロのクリエイターに最適',
        PLAN_ENTRY_description: '初心者クリエイターに最適',
        PLAN_BASIC_description: '中級クリエイターに最適',
        get_credits_instantly: '毎月獲得可能',
        get_credits_count: '{count} クレジット',
        VIP: 'VIP',
        credits: 'クレジット',
        chat_plan: 'チャットVIP',
        max_music_count: '最大 {count} 首音楽',
        airwallex: '', // Pending alignment
    },
    ko: {
        getMonthlyCredits: '{count} 크레딧/월',
        // 페이지 제목
        plansAndPricing: '플랜 및 가격',
        getAccessDescription:
            '더 많은 생성 횟수와 새 기능에 대한 우선 액세스 권한 획득',

        // 결제 주기
        monthly: '월간',
        yearly: '연간',
        yearlyDiscount: '최대 50% 할인',
        payAsYouGo: '사용량 기반',

        // 플랜 이름
        basic: '베이직',
        standard: '스탠다드',
        pro: '프로',
        popular: '인기',

        // 가격 관련
        month: '/월',
        billedYearly: '연간 결제',
        billedMonthly: '월간 결제',
        create: '지금 구매',

        // 크레딧 관련
        creditsPerMonth: '크레딧/월',
        creditsInstantly: '크레딧 즉시!',
        getCreditsInstantly: '🎉매달 {count} 크레딧을 획득!',

        // 기능
        textImageVideoToVideo: '텍스트/이미지/비디오에서 비디오로',
        upToImages: '최대 {count} 이미지',
        upToVideos: '최대 {count} 비디오',
        noWatermarkOutputs: '워터마크 없는 출력',
        unlimitedEditTools: '무제한 AI 편집 도구',
        priorityFastGeneration: '우선 빠른 생성',

        // FAQ 섹션
        frequentlyAskedQuestions: '자주 묻는 질문',
        cantFindAnswer: '찾고 계신 답변을 찾을 수 없나요?',

        // FAQ 질문
        paymentMethodsQuestion: '어떤 결제 방법을 받으시나요?',
        paymentMethodsAnswer:
            'Visa, MasterCard, American Express 등 주요 신용카드를 포함한 다양한 결제 방법을 받습니다.',

        creditsDeductionQuestion:
            '이미지나 비디오 생성 시 크레딧은 어떻게 차감되나요?',
        creditsDeductionAnswer:
            '크레딧 사용은 선택한 도구와 모델, 비디오 길이, 출력 수량, 이미지나 비디오의 해상도 등 몇 가지 요인에 따라 결정됩니다.',

        creditsRolloverQuestion: '미사용 크레딧이 다음 결제 주기로 이월되나요?',
        creditsRolloverAnswer:
            '미사용 크레딧은 다음 결제 주기로 이월되며, 계속 사용할 수 있습니다',

        needMoreCreditsQuestion: '더 많은 크레딧이 필요하면 어떻게 하나요?',
        needMoreCreditsAnswer:
            '무료 및 라이트 사용자의 경우, 더 많은 크레딧을 얻기 위해 플랜을 업그레이드할 수 있습니다. 프로 사용자의 경우, 위의 프로 플랜 아래의 크레딧 바로 쉽게 슬라이드하여 필요에 따라 추가 크레딧을 구매할 수 있습니다. 슬라이더를 원하는 추가 크레딧 수량까지 드래그하기만 하면 됩니다.',

        checkCreditStatusQuestion: '크레딧 상태를 확인하는 방법은?',
        checkCreditStatusAnswer:
            '화면 오른쪽 상단을 보거나 청구 페이지를 방문하여 크레딧 상태를 확인할 수 있습니다. 거기서 남은 월간 크레딧 수를 확인할 수 있습니다.',

        hiddenFeesQuestion: '숨겨진 수수료가 있나요?',
        hiddenFeesAnswer:
            '아니요, 보시는 가격이 지불하시는 가격입니다. 선택한 플랜 외에 추가적인 숨겨진 요금은 없습니다.',

        refundPolicyQuestion: '환불 정책은 무엇인가요?',
        refundPolicyAnswer: `첫 구매 후 3일 이내라면 환불을 요청할 수 있습니다. 자세한 내용은 <a href='https://weli.art/refund-policy' target='_blank' style='color: #4a9eff;text-decoration: underline;' >환불 정책</a>을 확인해 주세요.`,
        single_price: '${price} 크레딧당',
        payResult: {
            title: '결제 결과',
            loading: '결제 중...',
            success: '결제 성공',
            failed: '결제 실패',
        },
        choosePlan: '플랜 선택',
        choosePlanDescription:
            '스탠다드 또는 프로로 업그레이드하여 한 번에 최대 {count} 개의 이미지를 업로드하세요!',
        never_expire: '만료 없음',
        credits_monthly: '{count} 크레딧/월',
        actually: '실제',
        nanoAndSora: 'NanoBanana와 Sora2 모델',

        hotImageModel: '요즘 인기 있는 AI 이미지 모델',
        hotVideoModel: '요즘 인기 있는 AI 비디오 모델',
        videoBgRemove: '영상 배경 제거',
        videoWatermarkRemove: '영상 워터마크 제거',
        imageSizeControl: '이미지 비율 변환',
        moreTaskRunning: '다중 작업 동시 실행',
        speed1: '더 빠른 생성 속도',
        speed2: '초고속 생성 속도',
        speed3: '우선 채널 초고속 생성',
        copyrightProtection: '저작권 보호',
        maxConcurrentTasks: '최대 동시 {count} 작업',
        yearlyDiscountNumber: '{discount} 할인',
        hasSubscription: '현재 구독이 활성화되어 있습니다',
        choosePaymentMethod: '결제 방법 선택',
        orderGoods: '상품 주문',
        paymentInformationIsSafe: '귀하의 결제 정보는 안전합니다.',
        cancelSubscription: '언제든지 구독을 취소할 수 있습니다',
        payLoading: '주문 생성 중...',
        payConfirm: '지금 결제',
        supperMainbank: '주요 은행 카드 및 현지 결제 채널 지원',
        globalCreditCard: '글로벌 신용카드 / 직불카드 결제',
        chat_pro: '채팅 멤버십',
        can_cancel_at_any_time: '유연한 구독, 언제든지 취소 가능',
        only_need: '단지:',
        day_price: '{price}/일',
        chat_month_vip: '월간 VIP',
        chat_year_vip: '연간 VIP',
        year: '/년',
        can_cancel_at_any_time_yearly:
            '즉시 $100 절약, 장기 이용을 위한 최고의 선택',
        PLAN_PRO_description: '전문 크리에이터에게 적합',
        PLAN_ENTRY_description: '초보 크리에이터에게 적합',
        PLAN_BASIC_description: '고급 크리에이터에게 적합',
        get_credits_instantly: '매월 획득 가능',
        get_credits_count: '{count} 크레딧',
        VIP: 'VIP',
        credits: '크레딧',
        chat_plan: '채팅 VIP',
        max_music_count: '최대 {count} 首 음악',
        airwallex: '', // Pending alignment
    },
    tw: {
        getMonthlyCredits: '{count} 積分/月',
        // 頁面標題
        plansAndPricing: '方案與定價',
        getAccessDescription: '獲得更多生成次數與新功能優先體驗',

        // 計費週期
        monthly: '月付',
        yearly: '年付',
        yearlyDiscount: '最高可省 50%',
        payAsYouGo: '按需付費',

        // 方案名稱
        basic: '基礎版',
        standard: '標準版',
        pro: '專業版',
        popular: '熱門',

        // 價格相關
        month: '/月',
        billedYearly: '年付',
        billedMonthly: '月付',
        create: '立即購買',

        // 積分相關
        creditsPerMonth: '積分/月',
        creditsInstantly: '積分立即到帳！',
        getCreditsInstantly: '🎉每月可獲得 {count} 積分！',

        // 功能特性
        textImageVideoToVideo: '文字/圖片/影片轉影片',
        upToImages: '最多 {count} 張圖片',
        upToVideos: '最多 {count} 個影片',
        noWatermarkOutputs: '無浮水印輸出',
        unlimitedEditTools: '不限次 AI 編輯工具',
        priorityFastGeneration: '優先通道高速生成',

        // FAQ 區塊
        frequentlyAskedQuestions: '常見問題',
        cantFindAnswer: '找不到您要的答案？',

        // FAQ 問題
        paymentMethodsQuestion: '你們接受哪些付款方式？',
        paymentMethodsAnswer:
            '我們接受各種付款方式，包括主要信用卡，如 Visa、MasterCard、American Express 等。',

        creditsDeductionQuestion: '圖片或影片生成時如何扣除我的積分？',
        creditsDeductionAnswer:
            '積分使用會依您選擇的工具與模型、影片時長、輸出數量，以及圖片或影片解析度而定。',

        creditsRolloverQuestion: '未使用的積分會結轉到下個計費週期嗎？',
        creditsRolloverAnswer: '未使用的積分會結轉到下一期，可繼續使用',

        needMoreCreditsQuestion: '如果我需要更多積分怎麼辦？',
        needMoreCreditsAnswer:
            '免費與輕量版使用者可升級方案獲得更多積分。專業版使用者可拖動上方專業版方案下方的積分滑桿，依需求加購積分。',

        checkCreditStatusQuestion: '如何查看我的積分狀態？',
        checkCreditStatusAnswer:
            '您可查看畫面右上角或前往帳單頁面，查看剩餘的每月積分。',

        hiddenFeesQuestion: '是否有隱藏費用？',
        hiddenFeesAnswer:
            '沒有，您看到的價格就是實際支付的價格，除方案費用外沒有額外隱藏費用。',

        refundPolicyQuestion: '你們的退款政策是什麼？',
        refundPolicyAnswer: `首次購買後 3 天內可申請退款，詳情請參閱<a href='https://www.weryai.com.cn/refund-policy' target='_blank' style='color: #4a9eff;text-decoration: underline;' >《微鲤AI退款政策》</a>。`,
        single_price: '${price} / 積分',
        payResult: {
            title: '付款結果',
            loading: '付款中...',
            success: '付款成功',
            failed: '付款失敗',
        },
        choosePlan: '選擇您的方案',
        choosePlanDescription:
            '升級至標準或專業版，一次最多上傳 {count} 張圖片！',
        never_expire: '永久有效',
        credits_monthly: '{count} 積分/月',
        actually: '實際',
        nanoAndSora: 'NanoBanana 和 Sora2 模型',

        hotImageModel: '熱門 AI 圖像模型',
        hotVideoModel: '熱門 AI 影片模型',
        videoBgRemove: '影片去背',
        videoWatermarkRemove: '影片去浮水印',
        imageSizeControl: '圖片比例轉換',
        moreTaskRunning: '多任務並行',
        speed1: '更快的生成速度',
        speed2: '超快的生成速度',
        speed3: '優先通道高速生成',
        copyrightProtection: '版權保護',
        maxConcurrentTasks: '最多同時 {count} 個任務',
        yearlyDiscountNumber: '節省 {discount}',
        hasSubscription: '目前訂閱已啟用',
        choosePaymentMethod: '選擇付款方式',
        orderGoods: '下單商品',
        paymentInformationIsSafe: '您的付款資訊是安全的。',
        cancelSubscription: '可隨時取消訂閱',
        payLoading: '建立訂單中...',
        payConfirm: '立即付款',
        supperMainbank: '支援主流銀行卡與本地支付',
        globalCreditCard: '全球信用卡／簽帳卡支付',
        // Airwallex 支付相關
        airwallex: {
            title: '信用卡支付',
            subtitle: '請輸入信用卡資訊以完成付款',
            loading: '正在初始化付款...',
            processing: '處理中...',
            payNow: '立即付款',
            success: '付款成功！',
            initError: '付款系統初始化失敗，請稍後再試',
            createElementError: '建立付款表單失敗，請稍後再試',
            paymentError: '付款失敗，請重試',
            confirmError: '付款確認失敗，請重試',
            invalidGoods: '無效的商品資訊',
            cardNumber: '卡號',
            expiryDate: '有效期限',
            cvv: '安全碼',
            cardholderName: '卡片上的姓名',
            recaptchaError: '無法連線驗證服務，請檢查網路連線後再試',
            retry: '重試',
        },
        chat_pro: '聊天會員',
        can_cancel_at_any_time: '彈性訂閱，隨時取消',
        only_need: '僅需：',
        day_price: '{price}/天',
        chat_month_vip: '月度 VIP',
        chat_year_vip: '年度 VIP',
        year: '/年',
        can_cancel_at_any_time_yearly: '立省 $100，長期使用首選',
        PLAN_PRO_description: '適合專業創作者',
        PLAN_ENTRY_description: '適合入門創作者',
        PLAN_BASIC_description: '適合進階創作者',
        get_credits_instantly: '每月可獲得',
        get_credits_count: '{count} 積分',
        VIP: 'VIP',
        credits: '積分',
        chat_plan: '聊天VIP',
        max_music_count: '最多 {count} 首音樂',
    },
    pl: {
        getMonthlyCredits: '{count} kredytów/mies.',
        // Page titles
        plansAndPricing: 'Plany i ceny',
        getAccessDescription:
            'Więcej generacji i priorytetowy dostęp do nowych funkcji',

        // Billing cycles
        monthly: 'Miesięcznie',
        yearly: 'Rocznie',
        yearlyDiscount: 'Oszczędź do 50%',
        payAsYouGo: 'Płać w miarę użycia',

        // Plan names
        basic: 'Podstawowy',
        standard: 'Standard',
        pro: 'Pro',
        popular: 'Popularny',

        // Pricing related
        month: '/mies.',
        billedYearly: 'Rozliczenie roczne',
        billedMonthly: 'Rozliczenie miesięczne',
        create: 'Kup teraz',

        // Credits related
        creditsPerMonth: 'kredytów/mies.',
        creditsInstantly: 'kredyty od razu!',
        getCreditsInstantly: '🎉Co miesiąc {count} kredytów!',

        // Features
        textImageVideoToVideo: 'Tekst/Obraz/Wideo → wideo',
        upToImages: 'do {count} obrazów',
        upToVideos: 'do {count} wideo',
        noWatermarkOutputs: 'Wyniki bez znaku wodnego',
        unlimitedEditTools: 'Nielimitowane narzędzia edycji AI',
        priorityFastGeneration: 'Priorytetowe szybkie generowanie',

        // FAQ section
        frequentlyAskedQuestions: 'Najczęściej zadawane pytania',
        cantFindAnswer: 'Nie możesz znaleźć odpowiedzi?',

        // FAQ questions
        paymentMethodsQuestion: 'Jakie metody płatności akceptujecie?',
        paymentMethodsAnswer:
            'Akceptujemy różne metody płatności, w tym główne karty kredytowe, takie jak Visa, MasterCard czy American Express.',

        creditsDeductionQuestion:
            'Jak są potrącane kredyty za generowanie obrazów lub wideo?',
        creditsDeductionAnswer:
            'Zużycie kredytów zależy od wybranych narzędzi i modeli, długości wideo, liczby wyników oraz rozdzielczości.',

        creditsRolloverQuestion:
            'Czy niewykorzystane kredyty przechodzą na kolejny okres?',
        creditsRolloverAnswer:
            'Niewykorzystane kredyty przechodzą na kolejny okres i można je wykorzystać później.',

        needMoreCreditsQuestion: 'Co jeśli potrzebuję więcej kredytów?',
        needMoreCreditsAnswer:
            'Użytkownicy Free i Lite mogą przejść na wyższy plan. Użytkownicy Pro mogą przesunąć suwak kredytów pod planem Pro, aby dokupić dodatkowe kredyty.',

        checkCreditStatusQuestion: 'Jak sprawdzić stan kredytów?',
        checkCreditStatusAnswer:
            'Sprawdź w prawym górnym rogu ekranu lub na stronie Rozliczenia, aby zobaczyć pozostałe miesięczne kredyty.',

        hiddenFeesQuestion: 'Czy są ukryte opłaty?',
        hiddenFeesAnswer:
            'Nie. Cena, którą widzisz, to cena, którą płacisz. Poza wybranym planem nie ma dodatkowych opłat.',

        refundPolicyQuestion: 'Jaka jest polityka zwrotów?',
        refundPolicyAnswer: `Zwrot można zgłosić w ciągu 3 dni od pierwszego zakupu. Szczegóły znajdziesz w <a href='https://www.weryai.com.cn/refund-policy' target='_blank' style='color: #4a9eff;text-decoration: underline;' >Polityce zwrotów</a>.`,
        single_price: '${price} za kredyt',
        payResult: {
            title: 'Wynik płatności',
            loading: 'Trwa płatność...',
            success: 'Płatność zakończona',
            failed: 'Płatność nieudana',
        },
        choosePlan: 'Wybierz plan',
        choosePlanDescription:
            'Przejdź na Standard lub Pro, aby przesyłać do {count} obrazów naraz!',
        never_expire: 'Bez terminu ważności',
        credits_monthly: '{count} kredytów/mies.',
        actually: 'Rzeczywiste',
        nanoAndSora: 'Modele NanoBanana i Sora2',

        hotImageModel: 'Popularne modele obrazów AI',
        hotVideoModel: 'Popularne modele wideo AI',
        videoBgRemove: 'Usuwanie tła wideo',
        videoWatermarkRemove: 'Usuwanie znaku wodnego z wideo',
        imageSizeControl: 'Zmiana proporcji obrazu',
        moreTaskRunning: 'Wiele zadań równolegle',
        speed1: 'Szybsze generowanie',
        speed2: 'Błyskawiczne generowanie',
        speed3: 'Priorytetowe ultraszybkie generowanie',
        copyrightProtection: 'Ochrona praw autorskich',
        maxConcurrentTasks: 'Do {count} zadań jednocześnie',
        yearlyDiscountNumber: 'Oszczędzasz {discount}',
        hasSubscription: 'Bieżąca subskrypcja jest aktywna',
        choosePaymentMethod: 'Wybierz metodę płatności',
        orderGoods: 'Zamów produkt',
        paymentInformationIsSafe: 'Twoje dane płatnicze są bezpieczne.',
        cancelSubscription: 'Możesz anulować subskrypcję w dowolnym momencie',
        payLoading: 'Tworzenie zamówienia...',
        payConfirm: 'Zapłać teraz',
        supperMainbank:
            'Obsługuje główne karty bankowe i lokalne metody płatności',
        globalCreditCard: 'Płatność kartą kredytową/debetową (globalnie)',
        // Airwallex payment related
        airwallex: {
            title: 'Płatność kartą',
            subtitle: 'Wpisz dane karty, aby sfinalizować płatność',
            loading: 'Inicjowanie płatności...',
            processing: 'Przetwarzanie...',
            payNow: 'Zapłać teraz',
            success: 'Płatność zakończona!',
            initError:
                'Nie udało się zainicjować systemu płatności, spróbuj później',
            createElementError:
                'Nie udało się utworzyć formularza płatności, spróbuj później',
            paymentError: 'Płatność nie powiodła się, spróbuj ponownie',
            confirmError:
                'Potwierdzenie płatności nie powiodło się, spróbuj ponownie',
            invalidGoods: 'Nieprawidłowe informacje o produkcie',
            cardNumber: 'Numer karty',
            expiryDate: 'Data ważności',
            cvv: 'CVV',
            cardholderName: 'Imię i nazwisko na karcie',
            recaptchaError:
                'Nie można połączyć się z usługą weryfikacji. Sprawdź połączenie z internetem i spróbuj ponownie.',
            retry: 'Ponów',
        },
        chat_pro: 'Członkostwo czatu',
        can_cancel_at_any_time:
            'Elastyczna subskrypcja, anuluj w dowolnym momencie',
        only_need: 'Tylko:',
        day_price: '{price}/dzień',
        chat_month_vip: 'VIP miesięczny',
        chat_year_vip: 'VIP roczny',
        year: '/rok',
        can_cancel_at_any_time_yearly:
            'Oszczędź $100 od razu, najlepszy wybór na dłużej',
        PLAN_PRO_description: 'Idealne dla profesjonalnych twórców',
        PLAN_ENTRY_description: 'Idealne dla początkujących twórców',
        PLAN_BASIC_description: 'Idealne dla średniozaawansowanych twórców',
        get_credits_instantly: 'Co miesiąc otrzymasz',
        get_credits_count: '{count} kredytów',
        VIP: 'VIP',
        credits: 'kredyty',
        chat_plan: 'Chat VIP',
        max_music_count: 'Do {count} utworów muzycznych',
    },
    es: {
        getMonthlyCredits: '{count} crédits/mes',
        // Títulos de página
        plansAndPricing: 'Planes y Precios',
        getAccessDescription:
            'Obtén acceso a más generaciones y acceso prioritario a nuevas funciones',

        // Ciclos de facturación
        monthly: 'Mensual',
        yearly: 'Anual',
        yearlyDiscount: 'Ahorra hasta un 50 %',
        payAsYouGo: 'Pago por Uso',

        // Nombres de planes
        basic: 'Básico',
        standard: 'Estándar',
        pro: 'Pro',
        popular: 'Popular',

        // Relacionado con precios
        month: '/Mes',
        billedYearly: 'Facturado anualmente',
        billedMonthly: 'Facturado mensualmente',
        create: 'Comprar ahora',

        // Relacionado con créditos
        creditsPerMonth: 'créditos/mes',
        creditsInstantly: 'créditos al instante!',
        getCreditsInstantly: '🎉¡Obtén {count} créditos cada mes!',

        // Características
        textImageVideoToVideo: 'Texto/Imagen/Video a video',
        upToImages: 'hasta {count} imagen',
        upToVideos: 'hasta {count} video',
        noWatermarkOutputs: 'Salidas sin marca de agua',
        unlimitedEditTools: 'Herramientas de edición de IA ilimitadas',
        priorityFastGeneration: 'Generación rápida prioritaria',

        // Sección FAQ
        frequentlyAskedQuestions: 'Preguntas Frecuentes',
        cantFindAnswer: '¿No encuentras la respuesta que buscas?',

        // Preguntas FAQ
        paymentMethodsQuestion: '¿Qué métodos de pago aceptan?',
        paymentMethodsAnswer:
            'Aceptamos varios métodos de pago, incluyendo las principales tarjetas de crédito como Visa, MasterCard, American Express, etc.',

        creditsDeductionQuestion:
            '¿Cómo se deducen mis créditos para la generación de imágenes o videos?',
        creditsDeductionAnswer:
            'Tus créditos se usan basándose en varios factores incluyendo las herramientas y modelos que elijas, la duración de los videos, la cantidad de salidas y la resolución de las imágenes o videos.',

        creditsRolloverQuestion:
            '¿Los créditos no utilizados se transfieren al siguiente ciclo de facturación?',
        creditsRolloverAnswer:
            'Los créditos no utilizados se transfieren al siguiente ciclo de facturación y pueden continuar utilizándose',

        needMoreCreditsQuestion: '¿Qué pasa si necesito más créditos?',
        needMoreCreditsAnswer:
            'Para usuarios gratuitos y lite, puedes actualizar tus planes para obtener más créditos. Para usuarios Pro, puedes deslizar fácilmente la barra de créditos debajo del plan Pro de arriba para comprar créditos adicionales según sea necesario. Simplemente arrastra el deslizador a la cantidad deseada de créditos adicionales que quieres comprar.',

        checkCreditStatusQuestion: '¿Cómo verifico mi estado de créditos?',
        checkCreditStatusAnswer:
            'Puedes verificar tu estado de créditos mirando en la esquina superior derecha de la pantalla o visitando la página de Facturación. Allí verás cuántos créditos mensuales te quedan.',

        hiddenFeesQuestion: '¿Hay tarifas ocultas?',
        hiddenFeesAnswer:
            'No, el precio que ves es el precio que pagas. No hay cargos ocultos adicionales más allá del plan que selecciones.',

        refundPolicyQuestion: '¿Cuál es su política de reembolso?',
        refundPolicyAnswer: `Puedes solicitar un reembolso dentro de los 3 días posteriores a tu primera compra. Lee nuestra <a href='https://weli.art/refund-policy' target='_blank' style='color: #4a9eff;text-decoration: underline;' >Política de Reembolso</a> para más detalles.`,
        single_price: '${price} por crédito',
        payResult: {
            title: 'Resultado del Pago',
            loading: 'Procesando pago...',
            success: 'Pago exitoso',
            failed: 'Pago fallido',
        },
        choosePlan: 'Elige Tu Plan',
        choosePlanDescription:
            '¡Actualiza a Estándar o Pro para subir hasta {count} imágenes a la vez!',
        never_expire: 'Nunca Expira',
        credits_monthly: '{count} créditos/mes',
        actually: 'Real',

        hotImageModel: 'Modelos de imágenes de IA populares ahora',
        hotVideoModel: 'Modelos de video de IA populares ahora',
        videoBgRemove: 'Eliminación de fondo de video',
        videoWatermarkRemove: 'Eliminación de marca de agua en video',
        imageSizeControl: 'Conversión de relación de aspecto de imagen',
        moreTaskRunning: 'Múltiples tareas en paralelo',
        speed1: 'Velocidad de generación más rápida',
        speed2: 'Velocidad de generación ultra rápida',
        speed3: 'Generación ultra rápida con prioridad',
        copyrightProtection: 'Protección de derechos de autor',
        maxConcurrentTasks: 'Hasta {count} tareas simultáneas',
        yearlyDiscountNumber: 'Ahorra {discount}',
        hasSubscription: 'La suscripción actual está activa',
        choosePaymentMethod: 'Elegir Método de Pago',
        orderGoods: 'Pedir Productos',
        paymentInformationIsSafe: 'Su información de pago es segura.',
        cancelSubscription:
            'Puede cancelar su suscripción en cualquier momento',
        payLoading: 'Creando pedido...',
        payConfirm: 'Pagar Ahora',
        supperMainbank:
            'Soporta tarjetas bancarias principales y canales de pago locales',
        globalCreditCard: 'Pago con tarjeta de crédito / débito global',
        chat_pro: 'Membresía de chat',
        can_cancel_at_any_time:
            'Suscripción flexible, cancela en cualquier momento',
        only_need: 'Solo necesitas:',
        day_price: '{price}/día',
        chat_month_vip: 'VIP mensual',
        chat_year_vip: 'VIP anual',
        year: '/Año',
        can_cancel_at_any_time_yearly:
            'Ahorra $100 al instante, la mejor opción para uso a largo plazo',
        PLAN_PRO_description: 'Ideal para creadores profesionales',
        PLAN_ENTRY_description: 'Ideal para creadores principiantes',
        PLAN_BASIC_description: 'Ideal para creadores avanzados',
        get_credits_instantly: 'Obtenible mensualmente',
        get_credits_count: '{count} créditos',
        VIP: 'VIP',
        credits: 'Créditos',
        chat_plan: 'Chat VIP',
        max_music_count: 'Hasta {count} música',
        nanoAndSora: '', // Pending alignment
        airwallex: '', // Pending alignment
    },
    fr: {
        // Titres de page
        plansAndPricing: 'Plans et Tarifs',
        getAccessDescription:
            'Accédez à plus de générations et à un accès prioritaire aux nouvelles fonctionnalités',

        // Cycles de facturation
        monthly: 'Mensuel',
        yearly: 'Annuel',
        yearlyDiscount: 'Économisez jusqu’à 50 %',
        payAsYouGo: "Paiement à l'Usage",

        // Noms de plans
        basic: 'Basique',
        standard: 'Standard',
        pro: 'Pro',
        popular: 'Populaire',

        // Relatif aux prix
        month: '/Mois',
        billedYearly: 'Facturé annuellement',
        billedMonthly: 'Facturé mensuellement',
        create: 'Créer',

        // Relatif aux crédits
        creditsPerMonth: 'crédits/mois',
        creditsInstantly: 'crédits instantanément!',
        getCreditsInstantly: '🎉Obtenez {count} crédits chaque mois !',

        // Caractéristiques
        textImageVideoToVideo: 'Texte/Image/Vidéo vers vidéo',
        upToImages: "jusqu'à {count} image",
        upToVideos: "jusqu'à {count} vidéo",
        noWatermarkOutputs: 'Sorties sans filigrane',
        unlimitedEditTools: "Outils d'édition IA illimités",
        priorityFastGeneration: 'Génération rapide prioritaire',

        // Section FAQ
        frequentlyAskedQuestions: 'Questions Fréquemment Posées',
        cantFindAnswer: 'Vous ne trouvez pas la réponse que vous cherchez?',

        // Questions FAQ
        paymentMethodsQuestion: 'Quels modes de paiement acceptez-vous?',
        paymentMethodsAnswer:
            'Nous acceptons divers modes de paiement, y compris les principales cartes de crédit comme Visa, MasterCard, American Express, etc.',

        creditsDeductionQuestion:
            "Comment mes crédits sont-ils déduits pour la génération d'images ou de vidéos?",
        creditsDeductionAnswer:
            'Vos crédits sont utilisés en fonction de plusieurs facteurs incluant les outils et modèles que vous choisissez, la durée des vidéos, la quantité de sorties et la résolution des images ou vidéos.',

        creditsRolloverQuestion:
            'Les crédits non utilisés sont-ils reportés au cycle de facturation suivant?',
        creditsRolloverAnswer:
            'Les crédits non utilisés sont reportés au cycle de facturation suivant et peuvent continuer à être utilisés',

        needMoreCreditsQuestion: "Que faire si j'ai besoin de plus de crédits?",
        needMoreCreditsAnswer:
            'Pour les utilisateurs gratuits et lite, vous pouvez mettre à niveau vos plans pour obtenir plus de crédits. Pour les utilisateurs Pro, vous pouvez facilement faire glisser la barre de crédits sous le plan Pro ci-dessus pour acheter des crédits supplémentaires selon vos besoins. Il suffit de faire glisser le curseur vers le montant souhaité de crédits supplémentaires que vous voulez acheter.',

        checkCreditStatusQuestion: 'Comment vérifier mon statut de crédits?',
        checkCreditStatusAnswer:
            "Vous pouvez vérifier votre statut de crédits en regardant dans le coin supérieur droit de l'écran ou en visitant la page Facturation. Là, vous verrez combien de crédits mensuels il vous reste.",

        hiddenFeesQuestion: 'Y a-t-il des frais cachés?',
        hiddenFeesAnswer:
            "Non, le prix que vous voyez est le prix que vous payez. Il n'y a pas de frais cachés supplémentaires au-delà du plan que vous sélectionnez.",

        refundPolicyQuestion: 'Quelle est votre politique de remboursement?',
        refundPolicyAnswer: `Vous pouvez demander un remboursement dans les 3 jours suivant votre premier achat. Veuillez lire notre <a href='https://weli.art/refund-policy' target='_blank' style='color: #4a9eff;text-decoration: underline;' >Politique de remboursement</a> pour plus de détails.`,
        single_price: '${price} par crédit',
        payResult: {
            title: 'Résultat du Paiement',
            loading: 'Paiement en cours...',
            success: 'Paiement réussi',
            failed: 'Paiement échoué',
        },
        choosePlan: 'Choisissez Votre Plan',
        choosePlanDescription:
            "Passez à Standard ou Pro pour télécharger jusqu'à {count} images à la fois !",
        never_expire: "N'expire Jamais",
        credits_monthly: '{count} crédits/mois',
        actually: 'Réel',

        hotImageModel: 'Modèles d’images IA tendance',
        hotVideoModel: 'Modèles de vidéos IA tendance',
        videoBgRemove: 'Suppression de l’arrière-plan vidéo',
        videoWatermarkRemove: 'Suppression du filigrane de la vidéo',
        imageSizeControl: "Conversion du format d'image",
        moreTaskRunning: 'Plusieurs tâches en parallèle',
        speed1: 'Vitesse de génération plus rapide',
        speed2: 'Vitesse de génération ultra rapide',
        speed3: 'Génération ultra rapide prioritaire',
        copyrightProtection: 'Protection des droits d’auteur',
        maxConcurrentTasks: "Jusqu'à {count} tâches simultanées",
        yearlyDiscountNumber: 'Économisez {discount}',
        hasSubscription: 'La souscription actuelle est active',
        choosePaymentMethod: 'Choisir le Mode de Paiement',
        orderGoods: 'Commander des Produits',
        paymentInformationIsSafe:
            'Vos informations de paiement sont sécurisées.',
        cancelSubscription:
            'Vous pouvez annuler votre abonnement à tout moment',
        payLoading: 'Création de la commande...',
        payConfirm: 'Payer Maintenant',
        supperMainbank:
            'Prend en charge les principales cartes bancaires et les canaux de paiement locaux',
        globalCreditCard: 'Paiement par carte de crédit / débit mondiale',
        chat_pro: 'Abonnement chat',
        can_cancel_at_any_time: 'Abonnement flexible, annulez à tout moment',
        only_need: 'Seulement :',
        day_price: '{price}/jour',
        chat_month_vip: 'VIP mensuel',
        chat_year_vip: 'VIP annuel',
        year: '/An',
        can_cancel_at_any_time_yearly:
            'Économisez 100 $ instantanément, le meilleur choix pour le long terme',
        PLAN_PRO_description: 'Idéal pour les créateurs professionnels',
        PLAN_ENTRY_description: 'Idéal pour les créateurs débutants',
        PLAN_BASIC_description: 'Idéal pour les créateurs avancés',
        get_credits_instantly: 'Obtenable mensuellement',
        get_credits_count: '{count} crédits',
        VIP: 'VIP',
        credits: 'Crédits',
        chat_plan: 'Chat VIP',
        max_music_count: "Jusqu'à {count} musique",
        getMonthlyCredits: '', // Pending alignment
        nanoAndSora: '', // Pending alignment
        airwallex: '', // Pending alignment
    },
    de: {
        getMonthlyCredits: '{count} Credits/Monat',
        // Seitentitel
        plansAndPricing: 'Pläne & Preise',
        getAccessDescription:
            'Erhalten Sie Zugang zu mehr Generationen und bevorzugten Zugang zu neuen Funktionen',

        // Abrechnungszyklen
        monthly: 'Monatlich',
        yearly: 'Jährlich',
        yearlyDiscount: 'Spare bis zu 50 %',
        payAsYouGo: 'Pay-as-you-go',

        // Plannamen
        basic: 'Basic',
        standard: 'Standard',
        pro: 'Pro',
        popular: 'Beliebt',

        // Preise bezogen
        month: '/Monat',
        billedYearly: 'Jährlich abgerechnet',
        billedMonthly: 'Monatlich abgerechnet',
        create: 'Erstellen',

        // Credits bezogen
        creditsPerMonth: 'Credits/Monat',
        creditsInstantly: 'Credits sofort!',
        getCreditsInstantly: '🎉Jeden Monat {count} Credits erhalten!',

        // Funktionen
        textImageVideoToVideo: 'Text/Bild/Video zu Video',
        upToImages: 'bis zu {count} Bild',
        upToVideos: 'bis zu {count} Video',
        noWatermarkOutputs: 'Wasserzeichen-freie Ausgaben',
        unlimitedEditTools: 'Unbegrenzte KI-Bearbeitungstools',
        priorityFastGeneration: 'Prioritäts-Schnellgenerierung',

        // FAQ-Bereich
        frequentlyAskedQuestions: 'Häufig Gestellte Fragen',
        cantFindAnswer: 'Können Sie die Antwort nicht finden, die Sie suchen?',

        // FAQ-Fragen
        paymentMethodsQuestion: 'Welche Zahlungsmethoden akzeptieren Sie?',
        paymentMethodsAnswer:
            'Wir akzeptieren verschiedene Zahlungsmethoden, einschließlich der wichtigsten Kreditkarten wie Visa, MasterCard, American Express usw.',

        creditsDeductionQuestion:
            'Wie werden meine Credits für Bild- oder Videogenerierung abgezogen?',
        creditsDeductionAnswer:
            'Ihre Credits werden basierend auf mehreren Faktoren verwendet, einschließlich der Tools und Modelle, die Sie wählen, der Videolänge, der Anzahl der Ausgaben und der Auflösung der Bilder oder Videos.',

        creditsRolloverQuestion:
            'Werden ungenutzte Credits auf den nächsten Abrechnungszyklus übertragen?',
        creditsRolloverAnswer:
            'Ungenutzte Credits werden auf den nächsten Abrechnungszyklus übertragen und können weiterhin verwendet werden',

        needMoreCreditsQuestion: 'Was ist, wenn ich mehr Credits benötige?',
        needMoreCreditsAnswer:
            'Für kostenlose und Lite-Benutzer können Sie Ihre Pläne upgraden, um mehr Credits zu erhalten. Für Pro-Benutzer können Sie die Credit-Leiste unter dem Pro-Plan oben einfach schieben, um bei Bedarf zusätzliche Credits zu kaufen. Ziehen Sie einfach den Schieberegler auf die gewünschte Anzahl zusätzlicher Credits, die Sie kaufen möchten.',

        checkCreditStatusQuestion: 'Wie überprüfe ich meinen Credit-Status?',
        checkCreditStatusAnswer:
            'Sie können Ihren Credit-Status überprüfen, indem Sie in die obere rechte Ecke des Bildschirms schauen oder die Abrechnungsseite besuchen. Dort sehen Sie, wie viele monatliche Credits Sie noch haben.',

        hiddenFeesQuestion: 'Gibt es versteckte Gebühren?',
        hiddenFeesAnswer:
            'Nein, der Preis, den Sie sehen, ist der Preis, den Sie zahlen. Es gibt keine zusätzlichen versteckten Gebühren über den von Ihnen gewählten Plan hinaus.',

        refundPolicyQuestion: 'Wie ist Ihre Rückerstattungsrichtlinie?',
        refundPolicyAnswer: `Sie können innerhalb von 3 Tagen nach Ihrem ersten Kauf eine Rückerstattung beantragen. Bitte lesen Sie unsere <a href='https://weli.art/refund-policy' target='_blank' style='color: #4a9eff;text-decoration: underline;' >Rückerstattungsrichtlinie</a> für weitere Details.`,
        single_price: '${price} pro Credit',
        payResult: {
            title: 'Zahlungsergebnis',
            loading: 'Zahlung läuft...',
            success: 'Zahlung erfolgreich',
            failed: 'Zahlung fehlgeschlagen',
        },
        choosePlan: 'Wählen Sie Ihren Plan',
        choosePlanDescription:
            'Upgraden Sie auf Standard oder Pro, um bis zu {count} Bilder auf einmal hochzuladen!',
        never_expire: 'Läuft Nie Ab',
        credits_monthly: '{count} Credits/Monat',
        actually: 'Tatsächlich',
        nanoAndSora: 'NanoBanana und Sora2 Modell',

        hotImageModel: 'Beliebte KI-Bildmodelle derzeit',
        hotVideoModel: 'Beliebte KI-Videomodelle derzeit',
        videoBgRemove: 'Entfernung des Videohintergrunds',
        videoWatermarkRemove: 'Entfernung des Video-Wasserzeichens',
        imageSizeControl: 'Umwandlung des Bildseitenverhältnisses',
        moreTaskRunning: 'Mehrere Aufgaben parallel',
        speed1: 'Schnellere Generierungsgeschwindigkeit',
        speed2: 'Ultraschnelle Generierungsgeschwindigkeit',
        speed3: 'Priorisierte ultraschnelle Generierung',
        copyrightProtection: 'Urheberrechtsschutz',
        maxConcurrentTasks: 'Bis zu {count} gleichzeitige Aufgaben',
        yearlyDiscountNumber: 'Spare {discount}',
        hasSubscription: 'Die aktuelle Abonnement ist aktiv',
        choosePaymentMethod: 'Zahlungsmethode Wählen',
        orderGoods: 'Waren Bestellen',
        paymentInformationIsSafe: 'Ihre Zahlungsinformationen sind sicher.',
        cancelSubscription: 'Sie können Ihr Abonnement jederzeit kündigen',
        payLoading: 'Bestellung wird erstellt...',
        payConfirm: 'Jetzt Zahlen',
        supperMainbank:
            'Unterstützt gängige Bankkarten und lokale Zahlungskanäle',
        globalCreditCard: 'Globale Kreditkarte / Debitkarte Zahlung',
        chat_pro: 'Chat-Mitgliedschaft',
        can_cancel_at_any_time: 'Flexibles Abonnement, jederzeit kündbar',
        only_need: 'Nur:',
        day_price: '{price}/Tag',
        chat_month_vip: 'Monatliches VIP',
        chat_year_vip: 'Jährliches VIP',
        year: '/Jahr',
        can_cancel_at_any_time_yearly:
            'Sparen Sie sofort $100, die beste Wahl für langfristige Nutzung',
        PLAN_PRO_description: 'Ideal für professionelle Ersteller',
        PLAN_ENTRY_description: 'Ideal für Einsteiger-Ersteller',
        PLAN_BASIC_description: 'Ideal für fortgeschrittene Ersteller',
        get_credits_instantly: 'Monatlich erhältlich',
        get_credits_count: '{count} Credits',
        VIP: 'VIP',
        credits: 'Credits',
        chat_plan: 'Chat VIP',
        max_music_count: 'Bis zu {count} Musik',
        airwallex: '', // Pending alignment
    },
    ru: {
        getMonthlyCredits: '{count} кредитов/месяц',
        // Заголовки страниц
        plansAndPricing: 'Планы и Цены',
        getAccessDescription:
            'Получите доступ к большему количеству генераций и приоритетный доступ к новым функциям',

        // Циклы выставления счетов
        monthly: 'Ежемесячно',
        yearly: 'Ежегодно',
        yearlyDiscount: 'Экономьте до 50 %',
        payAsYouGo: 'Оплата по факту использования',

        // Названия планов
        basic: 'Базовый',
        standard: 'Стандартный',
        pro: 'Профессиональный',
        popular: 'Популярный',

        // Связанное с ценами
        month: '/Месяц',
        billedYearly: 'Оплата ежегодно',
        billedMonthly: 'Оплата ежемесячно',
        create: 'Купить сейчас',

        // Связанное с кредитами
        creditsPerMonth: 'кредитов/месяц',
        creditsInstantly: 'кредитов мгновенно!',
        getCreditsInstantly: '🎉Получайте {count} кредитов каждый месяц!',

        // Функции
        textImageVideoToVideo: 'Текст/Изображение/Видео в видео',
        upToImages: 'до {count} изображений',
        upToVideos: 'до {count} видео',
        noWatermarkOutputs: 'Выходы без водяных знаков',
        unlimitedEditTools: 'Неограниченные инструменты редактирования ИИ',
        priorityFastGeneration: 'Приоритетная быстрая генерация',

        // Раздел FAQ
        frequentlyAskedQuestions: 'Часто Задаваемые Вопросы',
        cantFindAnswer: 'Не можете найти ответ, который ищете?',

        // Вопросы FAQ
        paymentMethodsQuestion: 'Какие способы оплаты вы принимаете?',
        paymentMethodsAnswer:
            'Мы принимаем различные способы оплаты, включая основные кредитные карты, такие как Visa, MasterCard, American Express и т.д.',

        creditsDeductionQuestion:
            'Как списываются мои кредиты за генерацию изображений или видео?',
        creditsDeductionAnswer:
            'Ваши кредиты расходуются на основе нескольких факторов, включая выбранные вами инструменты и модели, продолжительность видео, количество выходов и разрешение изображений или видео.',

        creditsRolloverQuestion:
            'Переносятся ли неиспользованные кредиты на следующий биллинговый цикл?',
        creditsRolloverAnswer:
            'Неиспользованные кредиты переносятся на следующий биллинговый цикл и могут продолжать использоваться',

        needMoreCreditsQuestion: 'Что делать, если мне нужно больше кредитов?',
        needMoreCreditsAnswer:
            'Для бесплатных и легких пользователей вы можете обновить свои планы, чтобы получить больше кредитов. Для пользователей Pro вы можете легко сдвинуть кредитную полосу под планом Pro выше, чтобы купить дополнительные кредиты по мере необходимости. Просто перетащите ползунок на желаемое количество дополнительных кредитов, которые вы хотите купить.',

        checkCreditStatusQuestion: 'Как проверить статус моих кредитов?',
        checkCreditStatusAnswer:
            'Вы можете проверить статус ваших кредитов, посмотрев в правый верхний угол экрана или посетив страницу Биллинга. Там вы увидите, сколько ежемесячных кредитов у вас осталось.',

        hiddenFeesQuestion: 'Есть ли скрытые комиссии?',
        hiddenFeesAnswer:
            'Нет, цена, которую вы видите, это цена, которую вы платите. Нет дополнительных скрытых сборов сверх выбранного вами плана.',

        refundPolicyQuestion: 'Какова ваша политика возврата?',
        refundPolicyAnswer: `Вы можете запросить возврат в течение 3 дней после первой покупки. Пожалуйста, прочитайте нашу <a href='https://weli.art/refund-policy' target='_blank' style='color: #4a9eff;text-decoration: underline;' >Политику возврата</a>, чтобы узнать подробности.`,
        single_price: '${price} за кредит',
        payResult: {
            title: 'Результат Платежа',
            loading: 'Обработка платежа...',
            success: 'Платеж успешен',
            failed: 'Платеж не удался',
        },
        choosePlan: 'Выберите Ваш План',
        choosePlanDescription:
            'Обновитесь до Стандартного или Профессионального, чтобы загружать до {count} изображений за раз!',
        never_expire: 'Никогда Не Истекает',
        credits_monthly: '{count} кредитов/месяц',
        actually: 'Фактически',
        nanoAndSora: 'NanoBanana и Sora2 модель',

        hotImageModel: 'Популярные сейчас модели ИИ для изображений',
        hotVideoModel: 'Популярные сейчас модели ИИ для видео',
        videoBgRemove: 'Удаление фона видео',
        videoWatermarkRemove: 'Удаление водяного знака с видео',
        imageSizeControl: 'Преобразование соотношения сторон изображения',
        moreTaskRunning: 'Несколько задач, выполняющихся параллельно',
        speed1: 'Более высокая скорость генерации',
        speed2: 'Сверхвысокая скорость генерации',
        speed3: 'Приоритетная сверхбыстрая генерация',
        copyrightProtection: 'Защита авторских прав',
        maxConcurrentTasks: 'До {count} одновременных задач',
        yearlyDiscountNumber: 'Экономия {discount}',
        hasSubscription: 'Текущая подписка активна',
        choosePaymentMethod: 'Выбрать Способ Оплаты',
        orderGoods: 'Заказать Товары',
        paymentInformationIsSafe: 'Ваша платежная информация защищена.',
        cancelSubscription: 'Вы можете отменить подписку в любое время',
        payLoading: 'Создание заказа...',
        payConfirm: 'Оплатить Сейчас',
        supperMainbank:
            'Поддерживает основные банковские карты и местные платежные каналы',
        globalCreditCard: 'Глобальная кредитная / дебетовая карта оплата',
        chat_pro: 'Подписка на чат',
        can_cancel_at_any_time: 'Гибкая подписка, отмена в любое время',
        only_need: 'Только:',
        day_price: '{price}/день',
        chat_month_vip: 'Ежемесячный VIP',
        chat_year_vip: 'Ежегодный VIP',
        year: '/Год',
        can_cancel_at_any_time_yearly:
            'Сэкономьте $100 мгновенно, лучший выбор для длительного использования',
        PLAN_PRO_description: 'Подходит для профессиональных создателей',
        PLAN_ENTRY_description: 'Подходит для начинающих создателей',
        PLAN_BASIC_description: 'Подходит для продвинутых создателей',
        get_credits_instantly: 'Можно получать ежемесячно',
        get_credits_count: '{count} кредитов',
        VIP: 'VIP',
        credits: 'Кредиты',
        chat_plan: 'Чат VIP',
        max_music_count: 'До {count} музыки',
        airwallex: '', // Pending alignment
    },
    pt: {
        getMonthlyCredits: '{count} créditos/mês',
        // Títulos de página
        plansAndPricing: 'Planos e Preços',
        getAccessDescription:
            'Obtenha acesso a mais gerações e acesso prioritário a novos recursos',

        // Ciclos de cobrança
        monthly: 'Mensal',
        yearly: 'Anual',
        yearlyDiscount: 'Economize até 50%',
        payAsYouGo: 'Pague Conforme Usa',

        // Nomes dos planos
        basic: 'Básico',
        standard: 'Padrão',
        pro: 'Pro',
        popular: 'Popular',

        // Relacionado a preços
        month: '/Mês',
        billedYearly: 'Cobrado anualmente',
        billedMonthly: 'Cobrado mensalmente',
        create: 'Criar',

        // Relacionado a créditos
        creditsPerMonth: 'créditos/mês',
        creditsInstantly: 'créditos instantaneamente!',
        getCreditsInstantly: '🎉Obtenha {count} créditos todos os meses!',

        // Recursos
        textImageVideoToVideo: 'Texto/Imagem/Vídeo para vídeo',
        upToImages: 'até {count} imagem',
        upToVideos: 'até {count} vídeo',
        noWatermarkOutputs: "Saídas sem marca d'água",
        unlimitedEditTools: 'Ferramentas de edição de IA ilimitadas',
        priorityFastGeneration: 'Geração rápida prioritária',

        // Seção FAQ
        frequentlyAskedQuestions: 'Perguntas Frequentes',
        cantFindAnswer: 'Não consegue encontrar a resposta que procura?',

        // Perguntas FAQ
        paymentMethodsQuestion: 'Quais métodos de pagamento vocês aceitam?',
        paymentMethodsAnswer:
            'Aceitamos vários métodos de pagamento, incluindo os principais cartões de crédito como Visa, MasterCard, American Express, etc.',

        creditsDeductionQuestion:
            'Como meus créditos são deduzidos para geração de imagem ou vídeo?',
        creditsDeductionAnswer:
            'Seus créditos são usados com base em alguns fatores, incluindo as ferramentas e modelos que você escolhe, a duração dos vídeos, a quantidade de saídas e a resolução das imagens ou vídeos.',

        creditsRolloverQuestion:
            'Créditos não utilizados são transferidos para o próximo ciclo de cobrança?',
        creditsRolloverAnswer:
            'Os créditos não utilizados são transferidos para o próximo ciclo de cobrança e podem continuar sendo usados',

        needMoreCreditsQuestion: 'E se eu precisar de mais créditos?',
        needMoreCreditsAnswer:
            'Para usuários gratuitos e lite, você pode atualizar seus planos para obter mais créditos. Para usuários Pro, você pode facilmente deslizar a barra de créditos abaixo do plano Pro acima para comprar créditos extras conforme necessário. Simplesmente arraste o controle deslizante para a quantidade desejada de créditos adicionais que você quer comprar.',

        checkCreditStatusQuestion: 'Como verificar meu status de créditos?',
        checkCreditStatusAnswer:
            'Você pode verificar seu status de créditos olhando no canto superior direito da tela ou visitando a página de Cobrança. Lá, você verá quantos créditos mensais restam.',

        hiddenFeesQuestion: 'Há taxas ocultas?',
        hiddenFeesAnswer:
            'Não, o preço que você vê é o preço que você paga. Não há cobranças ocultas adicionais além do plano que você seleciona.',

        refundPolicyQuestion: 'Qual é sua política de reembolso?',
        refundPolicyAnswer: `Você pode solicitar um reembolso dentro de 3 dias após sua primeira compra. Leia nossa <a href='https://weli.art/refund-policy' target='_blank' style='color: #4a9eff;text-decoration: underline;' >Política de Reembolso</a> para mais detalhes.`,
        single_price: '${price} por crédito',
        payResult: {
            title: 'Resultado do Pagamento',
            loading: 'Processando pagamento...',
            success: 'Pagamento bem-sucedido',
            failed: 'Pagamento falhou',
        },
        choosePlan: 'Escolha Seu Plano',
        choosePlanDescription:
            'Atualize para Standard ou Pro para fazer upload de até {count} imagens de uma vez!',
        never_expire: 'Nunca Expira',
        credits_monthly: '{count} créditos/mês',
        actually: 'Real',
        nanoAndSora: 'NanoBanana e Sora2 modelo',

        hotImageModel: 'Modelos de IA de imagem em alta no momento',
        hotVideoModel: 'Modelos de IA de vídeo em alta no momento',
        videoBgRemove: 'Remoção de fundo de vídeo',
        videoWatermarkRemove: 'Remoção de marca d’água de vídeo',
        imageSizeControl: 'Conversão de proporção de imagem',
        moreTaskRunning: 'Várias tarefas em paralelo',
        speed1: 'Velocidade de geração mais rápida',
        speed2: 'Velocidade de geração ultrarrápida',
        speed3: 'Geração ultrarrápida prioritária',
        copyrightProtection: 'Proteção de direitos autorais',
        maxConcurrentTasks: 'Até {count} tarefas simultâneas',
        yearlyDiscountNumber: 'Economize {discount}',
        hasSubscription: 'A subscrição atual está ativa',
        choosePaymentMethod: 'Escolher Método de Pagamento',
        orderGoods: 'Pedir Produtos',
        paymentInformationIsSafe:
            'Suas informações de pagamento estão seguras.',
        cancelSubscription:
            'Você pode cancelar sua assinatura a qualquer momento',
        payLoading: 'Criando pedido...',
        payConfirm: 'Pagar Agora',
        supperMainbank:
            'Suporta cartões bancários principais e canais de pagamento locais',
        globalCreditCard: 'Pagamento com cartão de crédito / débito global',
        chat_pro: 'Assinatura de chat',
        can_cancel_at_any_time:
            'Assinatura flexível, cancele a qualquer momento',
        only_need: 'Apenas:',
        day_price: '{price}/dia',
        chat_month_vip: 'VIP mensal',
        chat_year_vip: 'VIP anual',
        year: '/Ano',
        can_cancel_at_any_time_yearly:
            'Economize $100 instantaneamente, a melhor escolha para uso a longo prazo',
        PLAN_PRO_description: 'Ideal para criadores profissionais',
        PLAN_ENTRY_description: 'Ideal para criadores iniciantes',
        PLAN_BASIC_description: 'Ideal para criadores avançados',
        get_credits_instantly: 'Obtível mensalmente',
        get_credits_count: '{count} créditos',
        VIP: 'VIP',
        credits: 'Créditos',
        chat_plan: 'Chat VIP',
        max_music_count: 'Até {count} música',
        airwallex: '', // Pending alignment
    },
    it: {
        getMonthlyCredits: '{count} crediti/mese',
        // Titoli di pagina
        plansAndPricing: 'Piani e Prezzi',
        getAccessDescription:
            'Ottieni accesso a più generazioni e accesso prioritario alle nuove funzionalità',

        // Cicli di fatturazione
        monthly: 'Mensile',
        yearly: 'Annuale',
        yearlyDiscount: 'Risparmia fino al 50%',
        payAsYouGo: 'Paga Come Usi',

        // Nomi dei piani
        basic: 'Base',
        standard: 'Standard',
        pro: 'Pro',
        popular: 'Popolare',

        // Relativo ai prezzi
        month: '/Mese',
        billedYearly: 'Fatturato annualmente',
        billedMonthly: 'Fatturato mensilmente',
        create: 'Crea',

        // Relativo ai crediti
        creditsPerMonth: 'crediti/mese',
        creditsInstantly: 'crediti istantaneamente!',
        getCreditsInstantly: '🎉Ottieni {count} crediti ogni mese!',

        // Caratteristiche
        textImageVideoToVideo: 'Testo/Immagine/Video a video',
        upToImages: 'fino a {count} immagine',
        upToVideos: 'fino a {count} video',
        noWatermarkOutputs: 'Output senza filigrana',
        unlimitedEditTools: 'Strumenti di modifica IA illimitati',
        priorityFastGeneration: 'Generazione rapida prioritaria',

        // Sezione FAQ
        frequentlyAskedQuestions: 'Domande Frequenti',
        cantFindAnswer: 'Non riesci a trovare la risposta che stai cercando?',

        // Domande FAQ
        paymentMethodsQuestion: 'Quali metodi di pagamento accettate?',
        paymentMethodsAnswer:
            'Accettiamo vari metodi di pagamento, incluse le principali carte di credito come Visa, MasterCard, American Express, ecc.',

        creditsDeductionQuestion:
            'Come vengono dedotti i miei crediti per la generazione di immagini o video?',
        creditsDeductionAnswer:
            'I tuoi crediti vengono utilizzati in base a diversi fattori, inclusi gli strumenti e i modelli che scegli, la durata dei video, la quantità di output e la risoluzione delle immagini o video.',

        creditsRolloverQuestion:
            'I crediti non utilizzati vengono trasferiti al prossimo ciclo di fatturazione?',
        creditsRolloverAnswer:
            'I crediti non utilizzati vengono trasferiti al prossimo ciclo di fatturazione e possono continuare ad essere utilizzati',

        needMoreCreditsQuestion: 'Cosa succede se ho bisogno di più crediti?',
        needMoreCreditsAnswer:
            'Per gli utenti gratuiti e lite, puoi aggiornare i tuoi piani per ottenere più crediti. Per gli utenti Pro, puoi facilmente scorrere la barra dei crediti sotto il piano Pro sopra per acquistare crediti extra secondo necessità. Basta trascinare il cursore alla quantità desiderata di crediti aggiuntivi che vuoi acquistare.',

        checkCreditStatusQuestion: 'Come verifico il mio stato dei crediti?',
        checkCreditStatusAnswer:
            "Puoi verificare il tuo stato dei crediti guardando nell'angolo superiore destro dello schermo o visitando la pagina Fatturazione. Lì vedrai quanti crediti mensili ti rimangono.",

        hiddenFeesQuestion: 'Ci sono commissioni nascoste?',
        hiddenFeesAnswer:
            'No, il prezzo che vedi è il prezzo che paghi. Non ci sono commissioni nascoste aggiuntive oltre al piano che selezioni.',

        refundPolicyQuestion: 'Qual è la vostra politica di rimborso?',
        refundPolicyAnswer: `Puoi richiedere un rimborso entro 3 giorni dal tuo primo acquisto. Leggi la nostra <a href='https://weli.art/refund-policy' target='_blank' style='color: #4a9eff;text-decoration: underline;' >Politica di Rimborso</a> per maggiori dettagli.`,
        single_price: '${price} per credito',
        payResult: {
            title: 'Risultato del Pagamento',
            loading: 'Pagamento in corso...',
            success: 'Pagamento riuscito',
            failed: 'Pagamento fallito',
        },
        choosePlan: 'Scegli Il Tuo Piano',
        choosePlanDescription:
            'Passa a Standard o Pro per caricare fino a {count} immagini alla volta!',
        never_expire: 'Non Scade Mai',
        credits_monthly: '{count} crediti/mese',
        actually: 'Reale',
        nanoAndSora: 'NanoBanana e Sora2 modello',

        hotImageModel: 'Modelli di immagini IA di tendenza',
        hotVideoModel: 'Modelli di video IA di tendenza',
        videoBgRemove: 'Rimozione dello sfondo video',
        videoWatermarkRemove: 'Rimozione della filigrana dal video',
        imageSizeControl: "Conversione del formato d'immagine",
        moreTaskRunning: 'Più attività in esecuzione in parallelo',
        speed1: 'Velocità di generazione più veloce',
        speed2: 'Velocità di generazione ultra veloce',
        speed3: 'Generazione ultra veloce prioritaria',
        copyrightProtection: "Protezione del diritto d'autore",
        maxConcurrentTasks: 'Fino a {count} attività simultanee',
        yearlyDiscountNumber: 'Risparmia {discount}',
        hasSubscription: 'La sottoscrizione attuale è attiva',
        choosePaymentMethod: 'Scegli Metodo di Pagamento',
        orderGoods: 'Ordina Prodotti',
        paymentInformationIsSafe:
            'Le tue informazioni di pagamento sono sicure.',
        cancelSubscription:
            'Puoi cancellare il tuo abbonamento in qualsiasi momento',
        payLoading: 'Creazione ordine...',
        payConfirm: 'Paga Ora',
        supperMainbank:
            'Supporta le principali carte bancarie e i canali di pagamento locali',
        globalCreditCard: 'Pagamento con carta di credito / debito globale',
        chat_pro: 'Abbonamento chat',
        can_cancel_at_any_time:
            'Abbonamento flessibile, annulla in qualsiasi momento',
        only_need: 'Solo:',
        day_price: '{price}/giorno',
        chat_month_vip: 'VIP mensile',
        chat_year_vip: 'VIP annuale',
        year: '/Anno',
        can_cancel_at_any_time_yearly:
            "Risparmia subito $100, la scelta migliore per l'uso a lungo termine",
        PLAN_PRO_description: 'Ideale per creatori professionisti',
        PLAN_ENTRY_description: 'Ideale per creatori principianti',
        PLAN_BASIC_description: 'Ideale per creatori avanzati',
        get_credits_instantly: 'Ottenibile mensilmente',
        get_credits_count: '{count} crediti',
        VIP: 'VIP',
        credits: 'Crediti',
        chat_plan: 'Chat VIP',
        max_music_count: 'Fino a {count} musica',
        airwallex: '', // Pending alignment
    },
    ar: {
        getMonthlyCredits: '{count} رصيد/شهر',
        // عناوين الصفحات
        plansAndPricing: 'الخطط والأسعار',
        getAccessDescription:
            'احصل على وصول إلى المزيد من التوليدات ووصول أولوي للميزات الجديدة',

        // دورات الفوترة
        monthly: 'شهري',
        yearly: 'سنوي',
        yearlyDiscount: 'وفّر حتى 50٪',
        payAsYouGo: 'ادفع حسب الاستخدام',

        // أسماء الخطط
        basic: 'أساسي',
        standard: 'قياسي',
        pro: 'احترافي',
        popular: 'شائع',

        // متعلق بالأسعار
        month: '/شهر',
        billedYearly: 'فوترة سنوية',
        billedMonthly: 'فوترة شهرية',
        create: 'شراء الآن',

        // متعلق بالرصيد
        creditsPerMonth: 'رصيد/شهر',
        creditsInstantly: 'رصيد فوري!',
        getCreditsInstantly: '🎉احصل على {count} رصيداً كل شهر!',

        // الميزات
        textImageVideoToVideo: 'نص/صورة/فيديو إلى فيديو',
        upToImages: 'حتى {count} صورة',
        upToVideos: 'حتى {count} فيديو',
        noWatermarkOutputs: 'مخرجات بدون علامة مائية',
        unlimitedEditTools: 'أدوات تحرير ذكاء اصطناعي غير محدودة',
        priorityFastGeneration: 'توليد سريع أولوي',

        // قسم الأسئلة الشائعة
        frequentlyAskedQuestions: 'الأسئلة الشائعة',
        cantFindAnswer: 'لا يمكنك العثور على الإجابة التي تبحث عنها؟',

        // أسئلة الأسئلة الشائعة
        paymentMethodsQuestion: 'ما هي طرق الدفع التي تقبلونها؟',
        paymentMethodsAnswer:
            'نقبل طرق دفع متنوعة، بما في ذلك بطاقات الائتمان الرئيسية مثل Visa و MasterCard و American Express وغيرها.',

        creditsDeductionQuestion: 'كيف يتم خصم رصيدي لتوليد الصور أو الفيديو؟',
        creditsDeductionAnswer:
            'يتم استخدام رصيدك بناءً على عدة عوامل بما في ذلك الأدوات والنماذج التي تختارها، ومدة الفيديوهات، وكمية المخرجات، ودقة الصور أو الفيديوهات.',

        creditsRolloverQuestion:
            'هل يتم نقل الرصيد غير المستخدم إلى دورة الفوترة التالية؟',
        creditsRolloverAnswer:
            'يتم نقل الرصيد غير المستخدم إلى دورة الفوترة التالية ويمكن الاستمرار في استخدامه',

        needMoreCreditsQuestion: 'ماذا لو احتجت إلى المزيد من الرصيد؟',
        needMoreCreditsAnswer:
            'للمستخدمين المجانيين والمحدودين، يمكنك ترقية خططك للحصول على المزيد من الرصيد. لمستخدمي Pro، يمكنك بسهولة تحريك شريط الرصيد أسفل خطة Pro أعلاه لشراء رصيد إضافي حسب الحاجة. ما عليك سوى سحب المنزلق إلى الكمية المطلوبة من الرصيد الإضافي الذي تريد شراءه.',

        checkCreditStatusQuestion: 'كيف أتحقق من حالة رصيدي؟',
        checkCreditStatusAnswer:
            'يمكنك التحقق من حالة رصيدك بالنظر في الزاوية اليمنى العلوية من الشاشة أو زيارة صفحة الفوترة. هناك سترى كم رصيد شهري متبقي لديك.',

        hiddenFeesQuestion: 'هل هناك رسوم مخفية؟',
        hiddenFeesAnswer:
            'لا، السعر الذي تراه هو السعر الذي تدفعه. لا توجد رسوم مخفية إضافية بخلاف الخطة التي تختارها.',

        refundPolicyQuestion: 'ما هي سياسة الاسترداد الخاصة بكم؟',
        refundPolicyAnswer: `يمكنك طلب استرداد خلال 3 أيام من أول عملية شراء. يُرجى قراءة <a href='https://weli.art/refund-policy' target='_blank' style='color: #4a9eff;text-decoration: underline;' >سياسة الاسترداد</a> لمزيد من التفاصيل.`,
        single_price: '${price} لكل رصيد',
        payResult: {
            title: 'نتيجة الدفع',
            loading: 'جارٍ المعالجة...',
            success: 'تم الدفع بنجاح',
            failed: 'فشل الدفع',
        },
        choosePlan: 'اختر خطتك',
        choosePlanDescription:
            'قم بالترقية إلى Standard أو Pro لتحميل ما يصل إلى {count} صورة في المرة الواحدة!',
        never_expire: 'لا تنتهي صلاحيته أبداً',
        credits_monthly: '{count} رصيد/شهر',
        actually: 'فعلي',
        nanoAndSora: 'NanoBanana و Sora2 مودل',

        hotImageModel: 'نماذج صور ذكاء اصطناعي شائعة حالياً',
        hotVideoModel: 'نماذج فيديو ذكاء اصطناعي شائعة حالياً',
        videoBgRemove: 'إزالة خلفية الفيديو',
        videoWatermarkRemove: 'إزالة العلامة المائية من الفيديو',
        imageSizeControl: 'تحويل نسبة أبعاد الصورة',
        moreTaskRunning: 'مهام متعددة تعمل بالتوازي',
        speed1: 'سرعة توليد أسرع',
        speed2: 'سرعة توليد فائقة السرعة',
        speed3: 'توليد فائق السرعة مع أولوية',
        copyrightProtection: 'حماية حقوق الطبع والنشر',
        maxConcurrentTasks: 'حتى {count} مهام متزامنة',
        yearlyDiscountNumber: 'وفّر {discount}',
        hasSubscription: 'الاشتراك الحالي هو نشط',
        choosePaymentMethod: 'اختر طريقة الدفع',
        orderGoods: 'طلب البضائع',
        paymentInformationIsSafe: 'معلومات الدفع الخاصة بك آمنة.',
        cancelSubscription: 'يمكنك إلغاء الاشتراك في أي وقت',
        payLoading: 'جارٍ إنشاء الطلب...',
        payConfirm: 'ادفع الآن',
        supperMainbank: 'يدعم بطاقات البنوك الرئيسية وقنوات الدفع المحلية',
        globalCreditCard: 'دفع بالبطاقة الائتمانية / الخصم العالمية',
        chat_pro: 'عضوية الدردشة',
        can_cancel_at_any_time: 'اشتراك مرن، يمكنك الإلغاء في أي وقت',
        only_need: 'تحتاج فقط إلى:',
        day_price: '{price}/يوم',
        chat_month_vip: 'عضوية VIP شهرية',
        chat_year_vip: 'عضوية VIP سنوية',
        year: '/سنة',
        can_cancel_at_any_time_yearly:
            'وفر 100 دولار فوراً، الخيار الأول للاستخدام طويل الأمد',
        PLAN_PRO_description: 'مناسب للمبدعين المحترفين',
        PLAN_ENTRY_description: 'مناسب للمبدعين المبتدئين',
        PLAN_BASIC_description: 'مناسب للمبدعين المتقدمين',
        get_credits_instantly: 'يمكن الحصول عليها شهرياً',
        get_credits_count: '{count} رصيد',
        VIP: 'VIP',
        credits: 'رصيد',
        chat_plan: 'دردشة VIP',
        max_music_count: 'حتى {count} موسيقى',
        airwallex: '', // Pending alignment
    },
    th: {
        getMonthlyCredits: '{count} เครดิต/เดือน',
        // Page titles
        plansAndPricing: 'แผนและราคา',
        getAccessDescription:
            'รับสิทธิ์เข้าถึงการสร้างเพิ่มเติมและการเข้าถึงฟีเจอร์ใหม่ก่อนใคร',

        // Billing cycles
        monthly: 'รายเดือน',
        yearly: 'รายปี',
        yearlyDiscount: 'ประหยัดสูงสุด 50%',
        payAsYouGo: 'จ่ายตามการใช้งาน',

        // Plan names
        basic: 'พื้นฐาน',
        standard: 'มาตรฐาน',
        pro: 'โปร',
        popular: 'ยอดนิยม',

        // Pricing related
        month: '/เดือน',
        billedYearly: 'เรียกเก็บเงินรายปี',
        billedMonthly: 'เรียกเก็บเงินรายเดือน',
        create: 'ซื้อเลย',

        // Credits related
        creditsPerMonth: 'เครดิต/เดือน',
        creditsInstantly: 'เครดิตทันที!',
        getCreditsInstantly: '🎉รับ {count} เครดิตทุกเดือน!',

        // Features
        textImageVideoToVideo: 'ข้อความ/รูปภาพ/วิดีโอ เป็น วิดีโอ',
        upToImages: 'สูงสุด {count} รูปภาพ',
        upToVideos: 'สูงสุด {count} วิดีโอ',
        noWatermarkOutputs: 'ผลลัพธ์ไม่มีลายน้ำ',
        unlimitedEditTools: 'เครื่องมือแก้ไข AI ไม่จำกัด',
        priorityFastGeneration: 'การสร้างด่วนแบบมีลำดับความสำคัญ',

        // FAQ section
        frequentlyAskedQuestions: 'คำถามที่พบบ่อย',
        cantFindAnswer: 'หาคำตอบที่คุณต้องการไม่เจอ?',

        // FAQ questions
        paymentMethodsQuestion: 'คุณรับวิธีการชำระเงินอะไรบ้าง?',
        paymentMethodsAnswer:
            'เรารับวิธีการชำระเงินหลากหลาย รวมถึงบัตรเครดิตหลักๆ เช่น Visa, MasterCard, American Express เป็นต้น',

        creditsDeductionQuestion:
            'เครดิตของฉันถูกหักอย่างไรสำหรับการสร้างรูปภาพหรือวิดีโอ?',
        creditsDeductionAnswer:
            'เครดิตของคุณถูกใช้ตามปัจจัยหลายอย่าง รวมถึงเครื่องมือและโมเดลที่คุณเลือก ระยะเวลาของวิดีโอ จำนวนผลลัพธ์ และความละเอียดของรูปภาพหรือวิดีโอ',

        creditsRolloverQuestion:
            'เครดิตที่ไม่ได้ใช้จะยกยอดไปรอบการเรียกเก็บเงินถัดไปหรือไม่?',
        creditsRolloverAnswer:
            'เครดิตที่ไม่ได้ใช้จะยกยอดไปรอบการเรียกเก็บเงินถัดไป สามารถใช้ต่อได้',

        needMoreCreditsQuestion: 'ถ้าฉันต้องการเครดิตเพิ่มเติมล่ะ?',
        needMoreCreditsAnswer:
            'สำหรับผู้ใช้ Free และ Lite คุณสามารถอัพเกรดแผนเพื่อรับเครดิตเพิ่มเติม สำหรับผู้ใช้ Pro คุณสามารถเลื่อนแถบเครดิตใต้แผน Pro ด้านบนเพื่อซื้อเครดิตเพิ่มเติมตามต้องการ เพียงลากตัวเลื่อนไปยังจำนวนเครดิตเพิ่มเติมที่คุณต้องการซื้อ',

        checkCreditStatusQuestion: 'ฉันจะตรวจสอบสถานะเครดิตได้อย่างไร?',
        checkCreditStatusAnswer:
            'คุณสามารถตรวจสอบสถานะเครดิตได้โดยดูที่มุมขวาบนของหน้าจอหรือเยี่ยมชมหน้าการเรียกเก็บเงิน ที่นั่นคุณจะเห็นว่าเหลือเครดิตรายเดือนเท่าไหร่',

        hiddenFeesQuestion: 'มีค่าธรรมเนียมแอบแฝงหรือไม่?',
        hiddenFeesAnswer:
            'ไม่ ราคาที่คุณเห็นคือราคาที่คุณจ่าย ไม่มีค่าใช้จ่ายแอบแฝงเพิ่มเติมนอกเหนือจากแผนที่คุณเลือก',

        refundPolicyQuestion: 'นโยบายการคืนเงินของคุณคืออะไร?',
        refundPolicyAnswer: `คุณสามารถขอคืนเงินได้ภายใน 3 วันหลังจากการซื้อครั้งแรก อ่าน<a href='https://www.weryai.com.cn/refund-policy' target='_blank' style='color: #4a9eff;text-decoration: underline;' >นโยบายการคืนเงิน</a>ของเราสำหรับรายละเอียดเพิ่มเติม`,
        single_price: '${price} ต่อเครดิต',
        payResult: {
            title: 'ผลการชำระเงิน',
            loading: 'กำลังดำเนินการชำระเงิน...',
            success: 'ชำระเงินสำเร็จ',
            failed: 'ชำระเงินล้มเหลว',
        },
        choosePlan: 'เลือกแผนของคุณ',
        choosePlanDescription:
            'อัพเกรดเป็น Standard หรือ Pro เพื่ออัปโหลดได้สูงสุด {count} รูปภาพในครั้งเดียว!',
        never_expire: 'ไม่มีวันหมดอายุ',
        credits_monthly: '{count} เครดิต/เดือน',
        actually: 'จริงๆ แล้ว',
        nanoAndSora: 'โมเดล NanoBanana และ Sora2',

        hotImageModel: 'โมเดลรูปภาพ AI ยอดนิยม',
        hotVideoModel: 'โมเดลวิดีโอ AI ยอดนิยม',
        videoBgRemove: 'ลบพื้นหลังวิดีโอ',
        videoWatermarkRemove: 'ลบลายน้ำวิดีโอ',
        imageSizeControl: 'แปลงอัตราส่วนภาพ',
        moreTaskRunning: 'หลายงานทำงานพร้อมกัน',
        speed1: 'ความเร็วในการสร้างเร็วขึ้น',
        speed2: 'ความเร็วในการสร้างเร็วมาก',
        speed3: 'การสร้างเร็วสุดแบบมีลำดับความสำคัญ',
        copyrightProtection: 'การปกป้องลิขสิทธิ์',
        maxConcurrentTasks: 'สูงสุด {count} งานพร้อมกัน',
        yearlyDiscountNumber: 'ประหยัด {discount}',
        hasSubscription: 'การสมัครสมาชิกปัจจุบันใช้งานอยู่',
        choosePaymentMethod: 'เลือกวิธีการชำระเงิน',
        orderGoods: 'สั่งซื้อสินค้า',
        paymentInformationIsSafe: 'ข้อมูลการชำระเงินของคุณปลอดภัย',
        cancelSubscription: 'คุณสามารถยกเลิกการสมัครสมาชิกได้ทุกเมื่อ',
        payLoading: 'กำลังสร้างคำสั่งซื้อ...',
        payConfirm: 'ชำระเงินเลย',
        supperMainbank: 'รองรับบัตรธนาคารหลักและช่องทางการชำระเงินในท้องถิ่น',
        globalCreditCard: 'ชำระเงินด้วยบัตรเครดิต / เดบิตทั่วโลก',
        airwallex: {
            title: 'ชำระเงินด้วยบัตรเครดิต',
            subtitle: 'กรุณากรอกข้อมูลบัตรเครดิตเพื่อดำเนินการชำระเงิน',
            loading: 'กำลังเริ่มต้นการชำระเงิน...',
            processing: 'กำลังดำเนินการ...',
            payNow: 'ชำระเงินเลย',
            success: 'ชำระเงินสำเร็จ!',
            initError: 'ระบบชำระเงินเริ่มต้นล้มเหลว กรุณาลองใหม่ภายหลัง',
            createElementError: 'สร้างฟอร์มชำระเงินล้มเหลว กรุณาลองใหม่ภายหลัง',
            paymentError: 'ชำระเงินล้มเหลว กรุณาลองใหม่',
            confirmError: 'ยืนยันการชำระเงินล้มเหลว กรุณาลองใหม่',
            invalidGoods: 'ข้อมูลสินค้าไม่ถูกต้อง',
            cardNumber: 'หมายเลขบัตร',
            expiryDate: 'วันหมดอายุ',
            cvv: 'CVV',
            cardholderName: 'ชื่อบนบัตร',
            recaptchaError:
                'ไม่สามารถเชื่อมต่อบริการตรวจสอบได้ กรุณาตรวจสอบการเชื่อมต่ออินเทอร์เน็ตแล้วลองใหม่',
            retry: 'ลองใหม่',
        },
        chat_pro: 'สมาชิกแชท',
        can_cancel_at_any_time: 'สมัครสมาชิกยืดหยุ่น ยกเลิกได้ทุกเมื่อ',
        only_need: 'เพียง:',
        day_price: '{price}/วัน',
        chat_month_vip: 'VIP รายเดือน',
        chat_year_vip: 'VIP รายปี',
        year: '/ปี',
        can_cancel_at_any_time_yearly:
            'ประหยัดทันที $100 ตัวเลือกที่ดีที่สุดสำหรับการใช้งานระยะยาว',
        PLAN_PRO_description: 'เหมาะสำหรับครีเอเตอร์มืออาชีพ',
        PLAN_ENTRY_description: 'เหมาะสำหรับครีเอเตอร์มือใหม่',
        PLAN_BASIC_description: 'เหมาะสำหรับครีเอเตอร์ระดับกลาง',
        get_credits_instantly: 'รับต่อเดือน',
        get_credits_count: '{count} เครดิต',
        VIP: 'VIP',
        credits: 'เครดิต',
        chat_plan: 'แชท VIP',
        max_music_count: 'สูงสุด {count} เพลง',
    },
    da: {
        getMonthlyCredits: '{count} kreditter/måned',
        // Page titles
        plansAndPricing: 'Planer og priser',
        getAccessDescription:
            'Få adgang til flere genereringer og prioriteret adgang til nye funktioner',

        // Billing cycles
        monthly: 'Månedlig',
        yearly: 'Årlig',
        yearlyDiscount: 'Spar op til 50%',
        payAsYouGo: 'Betal efter forbrug',

        // Plan names
        basic: 'Basis',
        standard: 'Standard',
        pro: 'Pro',
        popular: 'Populær',

        // Pricing related
        month: '/måned',
        billedYearly: 'Faktureres årligt',
        billedMonthly: 'Faktureres månedligt',
        create: 'Køb nu',

        // Credits related
        creditsPerMonth: 'kreditter/måned',
        creditsInstantly: 'kreditter med det samme!',
        getCreditsInstantly: '🎉Få {count} kreditter hver måned!',

        // Features
        textImageVideoToVideo: 'Tekst/Billede/Video til video',
        upToImages: 'op til {count} billede',
        upToVideos: 'op til {count} video',
        noWatermarkOutputs: 'Output uden vandmærke',
        unlimitedEditTools: 'Ubegrænsede AI-redigeringsværktøjer',
        priorityFastGeneration: 'Prioriteret hurtig generering',

        // FAQ section
        frequentlyAskedQuestions: 'Ofte stillede spørgsmål',
        cantFindAnswer: 'Kan du ikke finde det svar, du leder efter?',

        // FAQ questions
        paymentMethodsQuestion: 'Hvilke betalingsmetoder accepterer I?',
        paymentMethodsAnswer:
            'Vi accepterer forskellige betalingsmetoder, herunder større kreditkort som Visa, MasterCard, American Express osv.',

        creditsDeductionQuestion:
            'Hvordan trækkes mine kreditter for billed- eller videogenerering?',
        creditsDeductionAnswer:
            'Dine kreditter bruges baseret på flere faktorer, herunder de værktøjer og modeller du vælger, videoens varighed, antal output og billedets eller videoens opløsning.',

        creditsRolloverQuestion:
            'Overføres ubrugte kreditter til næste faktureringsperiode?',
        creditsRolloverAnswer:
            'Ubrugte kreditter overføres til næste faktureringsperiode og kan bruges igen',

        needMoreCreditsQuestion: 'Hvad hvis jeg har brug for flere kreditter?',
        needMoreCreditsAnswer:
            'For gratis og Lite-brugere kan du opgradere dine planer for at få flere kreditter. For Pro-brugere kan du nemt skubbe kreditbjælken under Pro-planen ovenfor for at købe ekstra kreditter efter behov. Træk blot skyderen til det ønskede antal ekstra kreditter, du vil købe.',

        checkCreditStatusQuestion: 'Hvordan tjekker jeg min kreditstatus?',
        checkCreditStatusAnswer:
            'Du kan tjekke din kreditstatus ved at kigge i øverste højre hjørne af skærmen eller besøge faktureringssiden. Der kan du se, hvor mange månedlige kreditter du har tilbage.',

        hiddenFeesQuestion: 'Er der skjulte gebyrer?',
        hiddenFeesAnswer:
            'Nej, den pris du ser, er den pris du betaler. Der er ingen ekstra skjulte gebyrer ud over den plan, du vælger.',

        refundPolicyQuestion: 'Hvad er jeres refusionspolitik?',
        refundPolicyAnswer: `Du kan anmode om refusion inden for 3 dage efter dit første køb. Læs vores <a href='https://www.weryai.com.cn/refund-policy' target='_blank' style='color: #4a9eff;text-decoration: underline;' >refusionspolitik</a> for flere detaljer.`,
        single_price: '${price} pr. kredit',
        payResult: {
            title: 'Betalingsresultat',
            loading: 'Betaling i gang...',
            success: 'Betaling gennemført',
            failed: 'Betaling mislykkedes',
        },
        choosePlan: 'Vælg din plan',
        choosePlanDescription:
            'Opgrader til Standard eller Pro for at uploade op til {count} billeder ad gangen!',
        never_expire: 'Udløber aldrig',
        credits_monthly: '{count} kreditter/måned',
        actually: 'Faktisk',
        nanoAndSora: 'NanoBanana og Sora2 model',

        hotImageModel: 'Populære AI-billedmodeller',
        hotVideoModel: 'Populære AI-videomodeller',
        videoBgRemove: 'Fjern videobaggrund',
        videoWatermarkRemove: 'Fjern videovandmærke',
        imageSizeControl: 'Billedforholdskonvertering',
        moreTaskRunning: 'Flere opgaver kører parallelt',
        speed1: 'Hurtigere genereringshastighed',
        speed2: 'Superhurtig genereringshastighed',
        speed3: 'Prioriteret ultrahurtig generering',
        copyrightProtection: 'Ophavsretsbeskyttelse',
        maxConcurrentTasks: 'Op til {count} samtidige opgaver',
        yearlyDiscountNumber: 'Spar {discount}',
        hasSubscription: 'Nuværende abonnement er aktivt',
        choosePaymentMethod: 'Vælg betalingsmetode',
        orderGoods: 'Bestil varer',
        paymentInformationIsSafe: 'Dine betalingsoplysninger er sikre.',
        cancelSubscription: 'Du kan annullere dit abonnement når som helst',
        payLoading: 'Opretter ordre...',
        payConfirm: 'Betal nu',
        supperMainbank:
            'Understøtter større bankkort og lokale betalingskanaler',
        globalCreditCard: 'Global kredit-/betalingskortbetaling',
        airwallex: {
            title: 'Kreditkortbetaling',
            subtitle:
                'Indtast venligst dine kreditkortoplysninger for at gennemføre betalingen',
            loading: 'Initialiserer betaling...',
            processing: 'Behandler...',
            payNow: 'Betal nu',
            success: 'Betaling gennemført!',
            initError:
                'Betalingssystem initialisering mislykkedes, prøv venligst igen senere',
            createElementError:
                'Kunne ikke oprette betalingsformular, prøv venligst igen senere',
            paymentError: 'Betaling mislykkedes, prøv venligst igen',
            confirmError:
                'Betalingsbekræftelse mislykkedes, prøv venligst igen',
            invalidGoods: 'Ugyldige produktoplysninger',
            cardNumber: 'Kortnummer',
            expiryDate: 'Udløbsdato',
            cvv: 'CVV',
            cardholderName: 'Navn på kort',
            recaptchaError:
                'Kunne ikke oprette forbindelse til verifikationstjenesten. Tjek venligst din internetforbindelse og prøv igen.',
            retry: 'Prøv igen',
        },
        chat_pro: 'Chat-medlemskab',
        can_cancel_at_any_time: 'Fleksibelt abonnement, annuller når som helst',
        only_need: 'Kun:',
        day_price: '{price}/dag',
        chat_month_vip: 'Månedlig VIP',
        chat_year_vip: 'Årlig VIP',
        year: '/år',
        can_cancel_at_any_time_yearly:
            'Spar $100 med det samme, bedst til langvarig brug',
        PLAN_PRO_description: 'Ideel til professionelle skabere',
        PLAN_ENTRY_description: 'Ideel til begyndere',
        PLAN_BASIC_description: 'Ideel til øvede skabere',
        get_credits_instantly: 'Få hver måned',
        get_credits_count: '{count} kreditter',
        VIP: 'VIP',
        credits: 'kreditter',
        chat_plan: 'Chat VIP',
        max_music_count: 'Op til {count} sange',
    },
    no: {
        getMonthlyCredits: '{count} kreditter/måned',
        // Page titles
        plansAndPricing: 'Planer og priser',
        getAccessDescription:
            'Få tilgang til flere genereringer og prioritert tilgang til nye funksjoner',

        // Billing cycles
        monthly: 'Månedlig',
        yearly: 'Årlig',
        yearlyDiscount: 'Spar opptil 50%',
        payAsYouGo: 'Betal etter bruk',

        // Plan names
        basic: 'Basis',
        standard: 'Standard',
        pro: 'Pro',
        popular: 'Populær',

        // Pricing related
        month: '/måned',
        billedYearly: 'Faktureres årlig',
        billedMonthly: 'Faktureres månedlig',
        create: 'Kjøp nå',

        // Credits related
        creditsPerMonth: 'kreditter/måned',
        creditsInstantly: 'kreditter umiddelbart!',
        getCreditsInstantly: '🎉Få {count} kreditter hver måned!',

        // Features
        textImageVideoToVideo: 'Tekst/Bilde/Video til video',
        upToImages: 'opptil {count} bilde',
        upToVideos: 'opptil {count} video',
        noWatermarkOutputs: 'Utdata uten vannmerke',
        unlimitedEditTools: 'Ubegrensede AI-redigeringsverktøy',
        priorityFastGeneration: 'Prioritert rask generering',

        // FAQ section
        frequentlyAskedQuestions: 'Ofte stilte spørsmål',
        cantFindAnswer: 'Finner du ikke svaret du leter etter?',

        // FAQ questions
        paymentMethodsQuestion: 'Hvilke betalingsmetoder godtar dere?',
        paymentMethodsAnswer:
            'Vi godtar ulike betalingsmetoder, inkludert store kredittkort som Visa, MasterCard, American Express osv.',

        creditsDeductionQuestion:
            'Hvordan trekkes kredittene mine for bilde- eller videogenerering?',
        creditsDeductionAnswer:
            'Kredittene dine brukes basert på flere faktorer, inkludert verktøyene og modellene du velger, videoens varighet, antall utdata og oppløsningen på bildene eller videoene.',

        creditsRolloverQuestion:
            'Overføres ubrukte kreditter til neste faktureringsperiode?',
        creditsRolloverAnswer:
            'Ubrukte kreditter overføres til neste faktureringsperiode og kan brukes igjen',

        needMoreCreditsQuestion: 'Hva om jeg trenger flere kreditter?',
        needMoreCreditsAnswer:
            'For gratis og Lite-brukere kan du oppgradere planene dine for å få flere kreditter. For Pro-brukere kan du enkelt skyve kredittlinjen under Pro-planen ovenfor for å kjøpe ekstra kreditter etter behov. Bare dra glidebryteren til ønsket antall ekstra kreditter du vil kjøpe.',

        checkCreditStatusQuestion: 'Hvordan sjekker jeg kredittstatus?',
        checkCreditStatusAnswer:
            'Du kan sjekke kredittstatus ved å se øverst til høyre på skjermen eller besøke faktureringssiden. Der vil du se hvor mange månedlige kreditter du har igjen.',

        hiddenFeesQuestion: 'Er det skjulte gebyrer?',
        hiddenFeesAnswer:
            'Nei, prisen du ser er prisen du betaler. Det er ingen ekstra skjulte gebyrer utover planen du velger.',

        refundPolicyQuestion: 'Hva er refusjonspolicyen deres?',
        refundPolicyAnswer: `Du kan be om refusjon innen 3 dager etter ditt første kjøp. Les vår <a href='https://www.weryai.com.cn/refund-policy' target='_blank' style='color: #4a9eff;text-decoration: underline;' >refusjonspolicy</a> for flere detaljer.`,
        single_price: '${price} per kreditt',
        payResult: {
            title: 'Betalingsresultat',
            loading: 'Betaling pågår...',
            success: 'Betaling vellykket',
            failed: 'Betaling mislyktes',
        },
        choosePlan: 'Velg din plan',
        choosePlanDescription:
            'Oppgrader til Standard eller Pro for å laste opp opptil {count} bilder om gangen!',
        never_expire: 'Utløper aldri',
        credits_monthly: '{count} kreditter/måned',
        actually: 'Faktisk',
        nanoAndSora: 'NanoBanana og Sora2 modell',

        hotImageModel: 'Populære AI-bildemodeller',
        hotVideoModel: 'Populære AI-videomodeller',
        videoBgRemove: 'Fjern videobakgrunn',
        videoWatermarkRemove: 'Fjern videovannmerke',
        imageSizeControl: 'Bildeforholdskonvertering',
        moreTaskRunning: 'Flere oppgaver kjører parallelt',
        speed1: 'Raskere genereringshastighet',
        speed2: 'Superrask genereringshastighet',
        speed3: 'Prioritert ultrarask generering',
        copyrightProtection: 'Opphavsrettsbeskyttelse',
        maxConcurrentTasks: 'Opptil {count} samtidige oppgaver',
        yearlyDiscountNumber: 'Spar {discount}',
        hasSubscription: 'Nåværende abonnement er aktivt',
        choosePaymentMethod: 'Velg betalingsmetode',
        orderGoods: 'Bestill varer',
        paymentInformationIsSafe: 'Betalingsinformasjonen din er sikker.',
        cancelSubscription: 'Du kan kansellere abonnementet når som helst',
        payLoading: 'Oppretter ordre...',
        payConfirm: 'Betal nå',
        supperMainbank: 'Støtter store bankkort og lokale betalingskanaler',
        globalCreditCard: 'Global kreditt-/debetkortbetaling',
        airwallex: {
            title: 'Kredittkortbetaling',
            subtitle:
                'Vennligst skriv inn kredittkortinformasjonen din for å fullføre betalingen',
            loading: 'Initialiserer betaling...',
            processing: 'Behandler...',
            payNow: 'Betal nå',
            success: 'Betaling vellykket!',
            initError:
                'Betalingssystem initialisering mislyktes, vennligst prøv igjen senere',
            createElementError:
                'Kunne ikke opprette betalingsskjema, vennligst prøv igjen senere',
            paymentError: 'Betaling mislyktes, vennligst prøv igjen',
            confirmError:
                'Betalingsbekreftelse mislyktes, vennligst prøv igjen',
            invalidGoods: 'Ugyldig produktinformasjon',
            cardNumber: 'Kortnummer',
            expiryDate: 'Utløpsdato',
            cvv: 'CVV',
            cardholderName: 'Navn på kort',
            recaptchaError:
                'Kunne ikke koble til verifiseringstjenesten. Vennligst sjekk internettforbindelsen og prøv igjen.',
            retry: 'Prøv igjen',
        },
        chat_pro: 'Chat-medlemskap',
        can_cancel_at_any_time:
            'Fleksibelt abonnement, kanseller når som helst',
        only_need: 'Bare:',
        day_price: '{price}/dag',
        chat_month_vip: 'Månedlig VIP',
        chat_year_vip: 'Årlig VIP',
        year: '/år',
        can_cancel_at_any_time_yearly:
            'Spar $100 med en gang, best for langtidsbruk',
        PLAN_PRO_description: 'Ideell for profesjonelle skapere',
        PLAN_ENTRY_description: 'Ideell for nybegynnere',
        PLAN_BASIC_description: 'Ideell for viderekomne skapere',
        get_credits_instantly: 'Få hver måned',
        get_credits_count: '{count} kreditter',
        VIP: 'VIP',
        credits: 'kreditter',
        chat_plan: 'Chat VIP',
        max_music_count: 'Opptil {count} sanger',
    },
    nl: {
        getMonthlyCredits: '{count} credits/maand',
        // Page titles
        plansAndPricing: 'Plannen en prijzen',
        getAccessDescription:
            'Krijg toegang tot meer generaties en prioriteitstoegang tot nieuwe functies',

        // Billing cycles
        monthly: 'Maandelijks',
        yearly: 'Jaarlijks',
        yearlyDiscount: 'Bespaar tot 50%',
        payAsYouGo: 'Betaal naar gebruik',

        // Plan names
        basic: 'Basis',
        standard: 'Standaard',
        pro: 'Pro',
        popular: 'Populair',

        // Pricing related
        month: '/maand',
        billedYearly: 'Jaarlijks gefactureerd',
        billedMonthly: 'Maandelijks gefactureerd',
        create: 'Koop nu',

        // Credits related
        creditsPerMonth: 'credits/maand',
        creditsInstantly: 'credits direct!',
        getCreditsInstantly: '🎉Krijg elke maand {count} credits!',

        // Features
        textImageVideoToVideo: 'Tekst/Afbeelding/Video naar video',
        upToImages: 'tot {count} afbeelding',
        upToVideos: 'tot {count} video',
        noWatermarkOutputs: 'Output zonder watermerk',
        unlimitedEditTools: 'Onbeperkte AI-bewerkingstools',
        priorityFastGeneration: 'Prioriteit snelle generatie',

        // FAQ section
        frequentlyAskedQuestions: 'Veelgestelde vragen',
        cantFindAnswer: 'Kunt u het antwoord dat u zoekt niet vinden?',

        // FAQ questions
        paymentMethodsQuestion: 'Welke betaalmethoden accepteren jullie?',
        paymentMethodsAnswer:
            'We accepteren verschillende betaalmethoden, waaronder grote creditcards zoals Visa, MasterCard, American Express, enz.',

        creditsDeductionQuestion:
            'Hoe worden mijn credits afgetrokken voor het genereren van afbeeldingen of video?',
        creditsDeductionAnswer:
            "Uw credits worden gebruikt op basis van verschillende factoren, waaronder de tools en modellen die u kiest, de duur van video's, het aantal outputs en de resolutie van de afbeeldingen of video's.",

        creditsRolloverQuestion:
            'Worden ongebruikte credits overgedragen naar de volgende factureringsperiode?',
        creditsRolloverAnswer:
            'Ongebruikte credits worden overgedragen naar de volgende factureringsperiode en kunnen opnieuw worden gebruikt',

        needMoreCreditsQuestion: 'Wat als ik meer credits nodig heb?',
        needMoreCreditsAnswer:
            'Voor gratis en Lite-gebruikers kunt u uw plannen upgraden om meer credits te krijgen. Voor Pro-gebruikers kunt u eenvoudig de creditbalk onder het Pro-plan hierboven schuiven om extra credits te kopen indien nodig. Sleep de schuifregelaar naar het gewenste aantal extra credits dat u wilt kopen.',

        checkCreditStatusQuestion: 'Hoe controleer ik mijn creditstatus?',
        checkCreditStatusAnswer:
            'U kunt uw creditstatus controleren door in de rechterbovenhoek van het scherm te kijken of de factureringspagina te bezoeken. Daar ziet u hoeveel maandelijkse credits u nog heeft.',

        hiddenFeesQuestion: 'Zijn er verborgen kosten?',
        hiddenFeesAnswer:
            'Nee, de prijs die u ziet is de prijs die u betaalt. Er zijn geen extra verborgen kosten naast het plan dat u selecteert.',

        refundPolicyQuestion: 'Wat is jullie terugbetalingsbeleid?',
        refundPolicyAnswer: `U kunt binnen 3 dagen na uw eerste aankoop een terugbetaling aanvragen. Lees ons <a href='https://www.weryai.com.cn/refund-policy' target='_blank' style='color: #4a9eff;text-decoration: underline;' >terugbetalingsbeleid</a> voor meer details.`,
        single_price: '${price} per credit',
        payResult: {
            title: 'Betalingsresultaat',
            loading: 'Betaling wordt verwerkt...',
            success: 'Betaling geslaagd',
            failed: 'Betaling mislukt',
        },
        choosePlan: 'Kies uw plan',
        choosePlanDescription:
            'Upgrade naar Standaard of Pro om tot {count} afbeeldingen tegelijk te uploaden!',
        never_expire: 'Verloopt nooit',
        credits_monthly: '{count} credits/maand',
        actually: 'Eigenlijk',
        nanoAndSora: 'NanoBanana en Sora2 model',

        hotImageModel: 'Populaire AI-afbeeldingsmodellen',
        hotVideoModel: 'Populaire AI-videomodellen',
        videoBgRemove: 'Video-achtergrond verwijderen',
        videoWatermarkRemove: 'Video-watermerk verwijderen',
        imageSizeControl: 'Beeldverhouding conversie',
        moreTaskRunning: 'Meerdere taken parallel',
        speed1: 'Snellere generatiesnelheid',
        speed2: 'Supersnelle generatiesnelheid',
        speed3: 'Prioriteit ultrasnelle generatie',
        copyrightProtection: 'Auteursrechtbescherming',
        maxConcurrentTasks: 'Tot {count} gelijktijdige taken',
        yearlyDiscountNumber: 'Bespaar {discount}',
        hasSubscription: 'Huidig abonnement is actief',
        choosePaymentMethod: 'Kies betaalmethode',
        orderGoods: 'Bestel producten',
        paymentInformationIsSafe: 'Uw betalingsgegevens zijn veilig.',
        cancelSubscription: 'U kunt uw abonnement op elk moment opzeggen',
        payLoading: 'Bestelling wordt aangemaakt...',
        payConfirm: 'Betaal nu',
        supperMainbank: 'Ondersteunt grote bankkaarten en lokale betaalkanalen',
        globalCreditCard: 'Wereldwijde creditcard / betaalpas betaling',
        airwallex: {
            title: 'Creditcardbetaling',
            subtitle:
                'Voer uw creditcardgegevens in om de betaling te voltooien',
            loading: 'Betaling initialiseren...',
            processing: 'Verwerken...',
            payNow: 'Betaal nu',
            success: 'Betaling geslaagd!',
            initError:
                'Betalingssysteem initialisatie mislukt, probeer het later opnieuw',
            createElementError:
                'Kan betalingsformulier niet maken, probeer het later opnieuw',
            paymentError: 'Betaling mislukt, probeer het opnieuw',
            confirmError: 'Betalingsbevestiging mislukt, probeer het opnieuw',
            invalidGoods: 'Ongeldige productinformatie',
            cardNumber: 'Kaartnummer',
            expiryDate: 'Vervaldatum',
            cvv: 'CVV',
            cardholderName: 'Naam op kaart',
            recaptchaError:
                'Kan geen verbinding maken met verificatieservice. Controleer uw internetverbinding en probeer het opnieuw.',
            retry: 'Opnieuw proberen',
        },
        chat_pro: 'Chat-lidmaatschap',
        can_cancel_at_any_time: 'Flexibel abonnement, op elk moment opzeggen',
        only_need: 'Slechts:',
        day_price: '{price}/dag',
        chat_month_vip: 'Maandelijks VIP',
        chat_year_vip: 'Jaarlijks VIP',
        year: '/jaar',
        can_cancel_at_any_time_yearly:
            'Bespaar direct $100, beste keuze voor langdurig gebruik',
        PLAN_PRO_description: 'Ideaal voor professionele makers',
        PLAN_ENTRY_description: 'Ideaal voor beginnende makers',
        PLAN_BASIC_description: 'Ideaal voor gevorderde makers',
        get_credits_instantly: 'Ontvang per maand',
        get_credits_count: '{count} kredieten',
        VIP: 'VIP',
        credits: 'kredieten',
        chat_plan: 'Chat VIP',
        max_music_count: 'Tot {count} nummers',
    },
    id: {
        getMonthlyCredits: '{count} kredit/bulan',
        // Page titles
        plansAndPricing: 'Paket dan Harga',
        getAccessDescription:
            'Dapatkan akses ke lebih banyak generasi dan akses prioritas ke fitur baru',

        // Billing cycles
        monthly: 'Bulanan',
        yearly: 'Tahunan',
        yearlyDiscount: 'Hemat hingga 50%',
        payAsYouGo: 'Bayar Sesuai Pemakaian',

        // Plan names
        basic: 'Dasar',
        standard: 'Standar',
        pro: 'Pro',
        popular: 'Populer',

        // Pricing related
        month: '/Bulan',
        billedYearly: 'Ditagih tahunan',
        billedMonthly: 'Ditagih bulanan',
        create: 'Beli Sekarang',

        // Credits related
        creditsPerMonth: 'kredit/bulan',
        creditsInstantly: 'kredit langsung!',
        getCreditsInstantly: '🎉Dapatkan {count} kredit setiap bulan!',

        // Features
        textImageVideoToVideo: 'Teks/Gambar/Video ke video',
        upToImages: 'hingga {count} gambar',
        upToVideos: 'hingga {count} video',
        noWatermarkOutputs: 'Output tanpa watermark',
        unlimitedEditTools: 'Alat pengeditan AI tak terbatas',
        priorityFastGeneration: 'Generasi cepat prioritas',

        // FAQ section
        frequentlyAskedQuestions: 'Pertanyaan yang Sering Diajukan',
        cantFindAnswer: 'Tidak dapat menemukan jawaban yang Anda cari?',

        // FAQ questions
        paymentMethodsQuestion: 'Metode pembayaran apa yang Anda terima?',
        paymentMethodsAnswer:
            'Kami menerima berbagai metode pembayaran, termasuk kartu kredit utama seperti Visa, MasterCard, American Express, dll.',

        creditsDeductionQuestion:
            'Bagaimana kredit saya dikurangi untuk pembuatan gambar atau video?',
        creditsDeductionAnswer:
            'Kredit Anda digunakan berdasarkan beberapa faktor termasuk alat dan model yang Anda pilih, durasi video, jumlah output, dan resolusi gambar atau video.',

        creditsRolloverQuestion:
            'Apakah kredit yang tidak digunakan dialihkan ke siklus penagihan berikutnya?',
        creditsRolloverAnswer:
            'Kredit yang tidak digunakan akan dialihkan ke siklus penagihan berikutnya dan dapat digunakan kembali',

        needMoreCreditsQuestion:
            'Bagaimana jika saya membutuhkan lebih banyak kredit?',
        needMoreCreditsAnswer:
            'Untuk pengguna Gratis dan Lite, Anda dapat meningkatkan paket untuk mendapatkan lebih banyak kredit. Untuk pengguna Pro, Anda dapat dengan mudah menggeser bilah kredit di bawah paket Pro di atas untuk membeli kredit tambahan sesuai kebutuhan. Cukup seret slider ke jumlah kredit tambahan yang diinginkan yang ingin Anda beli.',

        checkCreditStatusQuestion:
            'Bagaimana cara memeriksa status kredit saya?',
        checkCreditStatusAnswer:
            'Anda dapat memeriksa status kredit dengan melihat di sudut kanan atas layar atau mengunjungi halaman Penagihan. Di sana Anda akan melihat berapa banyak kredit bulanan yang tersisa.',

        hiddenFeesQuestion: 'Apakah ada biaya tersembunyi?',
        hiddenFeesAnswer:
            'Tidak, harga yang Anda lihat adalah harga yang Anda bayar. Tidak ada biaya tersembunyi tambahan di luar paket yang Anda pilih.',

        refundPolicyQuestion: 'Apa kebijakan pengembalian dana Anda?',
        refundPolicyAnswer: `Anda dapat meminta pengembalian dana dalam 3 hari setelah pembelian pertama Anda. Baca <a href='https://www.weryai.com.cn/refund-policy' target='_blank' style='color: #4a9eff;text-decoration: underline;' >Kebijakan Pengembalian Dana</a> kami untuk detail lebih lanjut.`,
        single_price: '${price} per kredit',
        payResult: {
            title: 'Hasil Pembayaran',
            loading: 'Pembayaran sedang diproses...',
            success: 'Pembayaran berhasil',
            failed: 'Pembayaran gagal',
        },
        choosePlan: 'Pilih Paket Anda',
        choosePlanDescription:
            'Tingkatkan ke Standar atau Pro untuk mengunggah hingga {count} gambar sekaligus!',
        never_expire: 'Tidak Pernah Kedaluwarsa',
        credits_monthly: '{count} kredit/bulan',
        actually: 'Sebenarnya',
        nanoAndSora: 'Model NanoBanana dan Sora2',

        hotImageModel: 'Model gambar AI yang sedang tren',
        hotVideoModel: 'Model video AI yang sedang tren',
        videoBgRemove: 'Penghapusan latar belakang video',
        videoWatermarkRemove: 'Penghapusan watermark video',
        imageSizeControl: 'Konversi rasio aspek gambar',
        moreTaskRunning: 'Beberapa tugas berjalan paralel',
        speed1: 'Kecepatan generasi lebih cepat',
        speed2: 'Kecepatan generasi super cepat',
        speed3: 'Generasi ultra cepat prioritas',
        copyrightProtection: 'Perlindungan hak cipta',
        maxConcurrentTasks: 'Hingga {count} tugas bersamaan',
        yearlyDiscountNumber: 'Hemat {discount}',
        hasSubscription: 'Langganan saat ini aktif',
        choosePaymentMethod: 'Pilih Metode Pembayaran',
        orderGoods: 'Pesan Produk',
        paymentInformationIsSafe: 'Informasi pembayaran Anda aman.',
        cancelSubscription: 'Anda dapat membatalkan langganan kapan saja',
        payLoading: 'Membuat pesanan...',
        payConfirm: 'Bayar Sekarang',
        supperMainbank:
            'Mendukung kartu bank utama dan saluran pembayaran lokal',
        globalCreditCard: 'Pembayaran kartu kredit / debit global',
        airwallex: {
            title: 'Pembayaran Kartu Kredit',
            subtitle:
                'Silakan masukkan informasi kartu kredit Anda untuk menyelesaikan pembayaran',
            loading: 'Menginisialisasi pembayaran...',
            processing: 'Memproses...',
            payNow: 'Bayar Sekarang',
            success: 'Pembayaran berhasil!',
            initError:
                'Inisialisasi sistem pembayaran gagal, silakan coba lagi nanti',
            createElementError:
                'Gagal membuat formulir pembayaran, silakan coba lagi nanti',
            paymentError: 'Pembayaran gagal, silakan coba lagi',
            confirmError: 'Konfirmasi pembayaran gagal, silakan coba lagi',
            invalidGoods: 'Informasi produk tidak valid',
            cardNumber: 'Nomor Kartu',
            expiryDate: 'Tanggal Kedaluwarsa',
            cvv: 'CVV',
            cardholderName: 'Nama di Kartu',
            recaptchaError:
                'Tidak dapat terhubung ke layanan verifikasi. Silakan periksa koneksi internet Anda dan coba lagi.',
            retry: 'Coba Lagi',
        },
        chat_pro: 'Keanggotaan Chat',
        can_cancel_at_any_time: 'Langganan fleksibel, batalkan kapan saja',
        only_need: 'Hanya:',
        day_price: '{price}/hari',
        chat_month_vip: 'VIP Bulanan',
        chat_year_vip: 'VIP Tahunan',
        year: '/Tahun',
        can_cancel_at_any_time_yearly:
            'Hemat $100 langsung, pilihan terbaik untuk penggunaan jangka panjang',
        PLAN_PRO_description: 'Cocok untuk kreator profesional',
        PLAN_ENTRY_description: 'Cocok untuk kreator pemula',
        PLAN_BASIC_description: 'Cocok untuk kreator tingkat menengah',
        get_credits_instantly: 'Dapatkan per bulan',
        get_credits_count: '{count} kredit',
        VIP: 'VIP',
        credits: 'kredit',
        chat_plan: 'Chat VIP',
        max_music_count: 'Hingga {count} lagu',
    },
    tr: {
        getMonthlyCredits: '{count} kredi/ay',
        // Page titles
        plansAndPricing: 'Planlar ve Fiyatlandırma',
        getAccessDescription:
            'Daha fazla üretim ve yeni özelliklere öncelikli erişim elde edin',

        // Billing cycles
        monthly: 'Aylık',
        yearly: 'Yıllık',
        yearlyDiscount: "%50'ye kadar tasarruf edin",
        payAsYouGo: 'Kullandıkça Öde',

        // Plan names
        basic: 'Temel',
        standard: 'Standart',
        pro: 'Pro',
        popular: 'Popüler',

        // Pricing related
        month: '/Ay',
        billedYearly: 'Yıllık faturalandırılır',
        billedMonthly: 'Aylık faturalandırılır',
        create: 'Şimdi Satın Al',

        // Credits related
        creditsPerMonth: 'kredi/ay',
        creditsInstantly: 'kredi anında!',
        getCreditsInstantly: '🎉Her ay {count} kredi kazanın!',

        // Features
        textImageVideoToVideo: "Metin/Görsel/Video'dan videoya",
        upToImages: "{count} görsel'e kadar",
        upToVideos: "{count} video'ya kadar",
        noWatermarkOutputs: 'Filigranlı çıktılar yok',
        unlimitedEditTools: 'Sınırsız AI düzenleme araçları',
        priorityFastGeneration: 'Öncelikli hızlı üretim',

        // FAQ section
        frequentlyAskedQuestions: 'Sıkça Sorulan Sorular',
        cantFindAnswer: 'Aradığınız cevabı bulamıyor musunuz?',

        // FAQ questions
        paymentMethodsQuestion: 'Hangi ödeme yöntemlerini kabul ediyorsunuz?',
        paymentMethodsAnswer:
            'Visa, MasterCard, American Express vb. gibi büyük kredi kartları dahil çeşitli ödeme yöntemlerini kabul ediyoruz.',

        creditsDeductionQuestion:
            'Görsel veya video üretimi için kredilerim nasıl düşülür?',
        creditsDeductionAnswer:
            'Kredileriniz, seçtiğiniz araçlar ve modeller, video süresi, çıktı miktarı ve görsel veya videoların çözünürlüğü dahil olmak üzere birkaç faktöre göre kullanılır.',

        creditsRolloverQuestion:
            'Kullanılmayan krediler bir sonraki fatura dönemine aktarılır mı?',
        creditsRolloverAnswer:
            'Kullanılmayan krediler bir sonraki fatura dönemine aktarılır ve tekrar kullanılabilir',

        needMoreCreditsQuestion: 'Daha fazla krediye ihtiyacım olursa ne olur?',
        needMoreCreditsAnswer:
            'Ücretsiz ve Lite kullanıcıları için daha fazla kredi almak için planlarınızı yükseltebilirsiniz. Pro kullanıcıları için yukarıdaki Pro planının altındaki kredi çubuğunu kolayca kaydırarak ihtiyaç duyduğunuzda ekstra kredi satın alabilirsiniz. Sadece kaydırıcıyı satın almak istediğiniz ek kredi miktarına sürükleyin.',

        checkCreditStatusQuestion: 'Kredi durumumu nasıl kontrol edebilirim?',
        checkCreditStatusAnswer:
            'Ekranın sağ üst köşesine bakarak veya Faturalama sayfasını ziyaret ederek kredi durumunuzu kontrol edebilirsiniz. Orada kaç aylık kredinizin kaldığını göreceksiniz.',

        hiddenFeesQuestion: 'Gizli ücretler var mı?',
        hiddenFeesAnswer:
            'Hayır, gördüğünüz fiyat ödediğiniz fiyattır. Seçtiğiniz planın ötesinde ek gizli ücret yoktur.',

        refundPolicyQuestion: 'İade politikanız nedir?',
        refundPolicyAnswer: `İlk satın alımınızdan sonraki 3 gün içinde iade talep edebilirsiniz. Daha fazla ayrıntı için <a href='https://www.weryai.com.cn/refund-policy' target='_blank' style='color: #4a9eff;text-decoration: underline;' >İade Politikamızı</a> okuyun.`,
        single_price: 'Kredi başına ${price}',
        payResult: {
            title: 'Ödeme Sonucu',
            loading: 'Ödeme işleniyor...',
            success: 'Ödeme başarılı',
            failed: 'Ödeme başarısız',
        },
        choosePlan: 'Planınızı Seçin',
        choosePlanDescription:
            "Aynı anda {count} görsel'e kadar yüklemek için Standart veya Pro'ya yükseltin!",
        never_expire: 'Asla Sona Ermez',
        credits_monthly: '{count} kredi/ay',
        actually: 'Aslında',
        nanoAndSora: 'NanoBanana ve Sora2 modeli',

        hotImageModel: 'Trend AI görsel modelleri',
        hotVideoModel: 'Trend AI video modelleri',
        videoBgRemove: 'Video arka plan kaldırma',
        videoWatermarkRemove: 'Video filigran kaldırma',
        imageSizeControl: 'Görsel en boy oranı dönüştürme',
        moreTaskRunning: 'Paralel çalışan birden fazla görev',
        speed1: 'Daha hızlı üretim hızı',
        speed2: 'Süper hızlı üretim hızı',
        speed3: 'Öncelikli ultra hızlı üretim',
        copyrightProtection: 'Telif hakkı koruması',
        maxConcurrentTasks: '{count} eşzamanlı göreve kadar',
        yearlyDiscountNumber: '{discount} tasarruf edin',
        hasSubscription: 'Mevcut abonelik aktif',
        choosePaymentMethod: 'Ödeme Yöntemi Seçin',
        orderGoods: 'Ürün Sipariş Et',
        paymentInformationIsSafe: 'Ödeme bilgileriniz güvende.',
        cancelSubscription:
            'Aboneliğinizi istediğiniz zaman iptal edebilirsiniz',
        payLoading: 'Sipariş oluşturuluyor...',
        payConfirm: 'Şimdi Öde',
        supperMainbank:
            'Büyük banka kartlarını ve yerel ödeme kanallarını destekler',
        globalCreditCard: 'Küresel kredi kartı / banka kartı ödemesi',
        airwallex: {
            title: 'Kredi Kartı Ödemesi',
            subtitle:
                'Ödemeyi tamamlamak için lütfen kredi kartı bilgilerinizi girin',
            loading: 'Ödeme başlatılıyor...',
            processing: 'İşleniyor...',
            payNow: 'Şimdi Öde',
            success: 'Ödeme başarılı!',
            initError:
                'Ödeme sistemi başlatma başarısız oldu, lütfen daha sonra tekrar deneyin',
            createElementError:
                'Ödeme formu oluşturulamadı, lütfen daha sonra tekrar deneyin',
            paymentError: 'Ödeme başarısız oldu, lütfen tekrar deneyin',
            confirmError: 'Ödeme onayı başarısız oldu, lütfen tekrar deneyin',
            invalidGoods: 'Geçersiz ürün bilgisi',
            cardNumber: 'Kart Numarası',
            expiryDate: 'Son Kullanma Tarihi',
            cvv: 'CVV',
            cardholderName: 'Karttaki İsim',
            recaptchaError:
                'Doğrulama hizmetine bağlanılamadı. Lütfen internet bağlantınızı kontrol edin ve tekrar deneyin.',
            retry: 'Tekrar Dene',
        },
        chat_pro: 'Sohbet Üyeliği',
        can_cancel_at_any_time: 'Esnek abonelik, istediğiniz zaman iptal edin',
        only_need: 'Sadece:',
        day_price: '{price}/gün',
        chat_month_vip: 'Aylık VIP',
        chat_year_vip: 'Yıllık VIP',
        year: '/Yıl',
        can_cancel_at_any_time_yearly:
            'Hemen $100 tasarruf, uzun vadeli kullanım için en iyi seçenek',
        PLAN_PRO_description: 'Profesyonel içerik üreticileri için ideal',
        PLAN_ENTRY_description: 'Yeni başlayan içerik üreticileri için ideal',
        PLAN_BASIC_description: 'Orta seviye içerik üreticileri için ideal',
        get_credits_instantly: 'Aylık olarak alın',
        get_credits_count: '{count} kredi',
        VIP: 'VIP',
        credits: 'kredi',
        chat_plan: 'Sohbet VIP',
        max_music_count: '{count} şarkıya kadar',
    },
}
